/**
 * Thousand Scripts
 *
 * This javascript file holds the custom code Thousand Helment
 * runs on the store.
 *
 * TODO: Refactor custom code from each template and move it here
 * if possible.
 *
 */


//TODO: fix missing Shopify global
var Shopify = Shopify || {};
Shopify.formatMoney = Shopify.formatMoney || function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_apostrophe_separator":r=i(t,2);break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)};

var formatMoneyStripTrailingZeros = function (cents, format) {
  if(!format){
  format = $('body').data('money-format');
}
  return Shopify.formatMoney(cents, format).replace('.00', '');
}

 // Register namespace
 window.thousand = window.thousand || {};

// Generate a private scope through this wrapper
(function () {

// Sub-namespaces
thousand.utils       = thousand.utils || {};
thousand.controllers = thousand.controllers || {};
thousand.callbacks   = thousand.callbacks || {};
thousand.helpers     = thousand.helpers || {};
thousand.assets      = thousand.assets || {};
thousand.globals     = thousand.globals || {};


var DEBUG = true;

// Logging function for this module. Enabled if DEBUG is enabled.
var log = DEBUG ? console.log.bind(console, '[Thousand]') : function () {};

/**
 * Extend jQuery easings
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
$.extend($.easing, {
    easeOutQuad: function (x, t, b, c, d) {
        return -c *(t/=d)*(t-2) + b;
    },
    easeOutCubic: function (x, t, b, c, d) {
        return c*((t=t/d-1)*t*t + 1) + b;
    }
});




// -----------------------------------------
// ------------- Utilities -----------------
// -----------------------------------------

/**
 * Return bool of window width
 *
 */
thousand.utils.isMobile = function () {
  return $(window).width() < 768;
}

/**
 * Return current product JSON data
 *
 * Cache data after first GET
 *
 */
thousand.utils.getCurrentProductJSON = function () {
  if(!thousand.globals.currentProductJSON){
    if (!$('.product_form').length){
      console.warn('Trying to get product data on a page without a product')
      return;
    }
    thousand.globals.currentProductJSON = $('.product_form').data('product');
  }
  return thousand.globals.currentProductJSON;
}

/**
 * Return products selected variant options as query string
 *
 * Examples:
 *
 *   var variant = { option1: 'Navy', option2: 'Small', option3: 'Premium' };
 *   thousand.utils.variantAsString(variant);
 *
 * Will return '?[option1name]=Navy&[option2name]=Small&[option3name]=Premium'
 *
 */
thousand.utils.variantAsQueryString = (variant, product) => (
  product.options.reduce((prevString, currOption, index) => (
    prevString + (index === 0 ? '' : '&') + thousand.utils.handlify(currOption) + '=' + thousand.utils.handlify(variant.options[index])
  ), '')
)

/**
 * Select product's variant from a string with format:
 *
 * <option1>:<option2>:<option3>
 *
 * Examples:
 *
 *   thousand.utils.variantFromName(product, 'Navy:Small');
 *   thousand.utils.variantFromName(product, 'Navy');
 *   thousand.utils.variantFromName(product, 'Navy::');
 *   thousand.utils.variantFromName(product, ':Small:');
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.utils.variantFromName = function (product, currentVariantOptions) {
  // look through product variants to find title that matches color AND size
  // map variant options arrays to lowercase to match
  let results;
  $.each(product.variants, function(index, variant){    
    var bool = currentVariantOptions.every(function (value) {
      return (variant.options.map((op)=>thousand.utils.handlify(op)).indexOf(value) >= 0);
    });
    if(bool){
      results = variant;
      return false;
    }    
  });
  return results;
}


/**
 * Execute functions in sequence using the same
 * input arguments every time.
 *
 * @param ...functions
 *
 * @return results
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.utils.sequence = function (/* ...functions */) {
  var functions = Array.prototype.slice.call(arguments);

  return function (/* ...args */) {
    var args = Array.prototype.slice.call(arguments);

    return functions.map(function (f, i) {
      return f.apply(null, args);
    });
  };
}


/**
 * Transform in text into a handle-like string.
 *
 * For example, it will transform "Carbon Black" into "carbon-black".
 *
 * @param text Any string
 * @return handle A lowercase string replacing whitespace with dashes.
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.utils.handlify = function (text) {
  text = String(text);

  return text
    ? text.toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^0-9a-zA-Z\-\_]+/g, '')
    : ""
  ;
}

// -----------------------------------------
// ------------- Callbacks -----------------
// -----------------------------------------



/**
 *
 * Callback for variant selection called from option_selection.js
 *
 * This callback hooks on Shopify's operation_selection.js
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.callbacks.onVariantSelected = function (variant, selector) {
  thousand.globals.currentVariantJSON = variant;
  $(document).trigger('thousand:variant:selected', variant, selector);  
};


/**
 * Register all the needed callbacks or hook into some global callback.
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.callbacks.init = function() {
};




// -----------------------------------------
// ------------- Controllers ---------------
// -----------------------------------------

/**
 * Hash Link Scroll
 *
 * Make all hash links (anchor) with data-scroll attribute to
 * scroll towards their target.
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.controllers.hashLinkScroll = function (args) {
  var options = {};
  $.extend(options, {
    scrollContainerSelector : 'html, body',
    speed  : 1,
    targetPositionOffset: -40,
    easing: 'easeOutCubic'
  }, args);

  // Retrieve Hash links filtering those that don't actually link to anything
  var $hashLinks = $('a[href*="#"][data-scroll]').not('[href="#"]').not('[href="#0"]')

  // Call for scroll animation
  function performScroll($target, done) {
    var $scrollContainer = $(options.scrollContainerSelector);

    // Calculate duration based on distance
    var distance = Math.abs($target.offset().top - $scrollContainer.offset().top);
     var duration = distance * (1/options.speed);
    var newTopPosition = Math.max(0, $target.offset().top + options.targetPositionOffset);

    return $scrollContainer.animate({ scrollTop: newTopPosition }, {
      duration : duration,
      easing: options.easing,
      complete: done
    });
  };

  // On-page links
  function isOnPageLink(link) {
    return (
      location.pathname.replace(/^\//, '') == link.pathname.replace(/^\//, '')
        &&
      location.hostname == link.hostname
     );
  };

  // Register click handler
  $hashLinks.click(function(event) {

      if (isOnPageLink(this)) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          performScroll($(target), function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });
};

/**
 * Simple Smooth scroll
 *
 */
thousand.controllers.smoothScroll = function () {
  $('body').on('click', '.smooth-scroll-btn', function(e) {
    e.preventDefault();
    $thisHash = $(this.hash);
    $('html, body').animate({
        scrollTop: $thisHash.offset().top
    }, 1000);
  });
}

/**
 * Scroll to element
 *
 * Use data-scroll-to="<selector>" attribute+value to scroll to
 * certain element.
 *
 * For example:
 *
 *    <a href="#" data-scroll-to="#footer">Go to footer</a>
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.controllers.scrollTo = function (args) {
  var options = {};
  $.extend(options, {
    selector : '[data-scroll-to]',
    scrollTarget : 'html, body',
    smooth : true,
    speed  : 1,
    targetPositionOffset: 0,
    easing: 'easeOutCubic',
    preventDefault : true,
    stopPropagation: true,

    // Attribute present on trigger to extract the selector used to find the target
    targetSelectorAttribute: 'data-scroll-to',

    // Calculate the selector for the target. Defaults uses
    // targetSelectorAttribute to grab the selector.
    // "this" context is the trigger element.
    targetSelector : function () {
      return $(this).attr(options.targetSelectorAttribute);
    },

    // Callbacks. They will receive the element that triggers the action,
    // this is, an individual element matching the options.selector
    onComplete : function(){},
    onStart    : function(){}
  }, args);


  $(options.selector).click(function (event) {

    var $trigger = $(this);
    var targetSelector = typeof options.targetSelector == 'function' ? options.targetSelector.call(this) : options.targetSelector;
    var $target = $(targetSelector);

    // Calculate duration based on distance
    var distance = Math.abs($target.offset().top - $trigger.offset().top);
     var duration = options.smooth
      ? distance * 2 * (1/options.speed)
      : 1
    ;

    // Call start callback
     ;

    // Execute animation
    $(options.scrollTarget).stop()
      .animate({
        scrollTop: $target.offset().top + options.targetPositionOffset
      }, {
        duration :duration,
        easing   : options.easing,
        start    : options.onStart.bind(this),
        complete : options.onComplete.bind(this)
      });

    // Evaluate default prevention
    if (options.preventDefault) {
    event.preventDefault();
    }

    // Evaluate propagation stop
    if (options.stopPropagation) {
      event.stopPropagation();
    }
  });

};


/**
 * Toggle Tab and Scroll Controller
 *
 * Use data-toggle-tab-and-scroll attribute to scroll to
 * tab content and enable it.
 *
 * Usage:
 *
 *    <a data-toggle-tab-and-scroll="<tabId>">...</a>
 *
 * Here the data-toggle-tab-and-scroll holds the id of the tab to trigger.
 *
 *
 * For example:
 *
 *    <a href="#" data-toggle-tab-and-scroll="#fitguide">See fit guide</a>
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.controllers.toggleTabAndScroll = function () {

  function getTabId() {
    // "this" must reference the trigger element.
    return $(this).attr('data-toggle-tab-and-scroll');
  };

  function isVisible(element) {
    return $(element).css('display') != 'none';
  }

  function isDesktop() {
    return isVisible($('#tabstyle'));
  }

  // Configure generic scrollTo controller
  thousand.controllers.scrollTo({
    selector : '[data-toggle-tab-and-scroll]',
    targetPositionOffset : -40,
    speed: 1,
    targetSelector : function () {
      var tabId = getTabId.call(this);
      var target;

      if (isDesktop()) {
        target = '[data-toggle="tab"][href="' + tabId + '"]';

      } else {
        // Detect the first accordion content opened, or select the actual target
        $('.accordion-toggle').each(function () {
            var $tab = $(this);
            var $content = $tab.next();

            if (target == null && isVisible($content)) {
              target = $tab;
            }
        });
        target = target || $('.accordion-toggle[data-tab-id="' + tabId + '"]');
      }

      return target;
    },
    onStart  : function () {
      // TODO: IMPROVE: This would be better to address directly in
      // code instead of triggering click.

      var tabId = getTabId.call(this);

      if (isDesktop()) {
        // Desktop case
        var $tab = $('a[href="' + tabId + '"][data-toggle="tab"]');
        $tab[0].click(); // unwrap

      } else {
        // Mobile case
        var $tab = $('.accordion-toggle[data-tab-id="' + tabId + '"]');
        var $tabContent = $($tab.next());

        if (!isVisible($tabContent)) {
          $tab.get(0).click()
        }

      }
    }
  });
};


/**
 * Handle "scrollTopButton", previously #myBtn
 *
 * @author Unknown, refactored by Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.controllers.scrollTopButton = function () {
  // When the user scrolls down ?px from the top of the document, show the button
  // When the user clicks on the button, scroll to the top of the document

  function shouldDisplayButton() {
    var bodyScrollTop = document.body.scrollTop;
    var documentScrollTop = document.documentElement.scrollTop;
    return bodyScrollTop > 1600 || documentScrollTop > 1600;
  }

  function scroll() {
    $('#scrollTopButton').css('display', shouldDisplayButton() ? 'block' : 'none');
  }

  function goToTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  $('#scrollTopButton').on('click', goToTop);

  $(window).on('scroll', scroll);
}


/**
 * Handle swatch tile click
 *
 * @author Unknown, refactored by Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.controllers.swatchTile = function () {
  $(".swatch-tile").click(function(e){
    e.preventDefault();
    var target = $(this).data("target-select");
    $(target).val($(this).data('value')).change();

    var selectedNow = $(this).parent().find(".swatch-tile");
    selectedNow.removeClass('active');
    $(this).addClass('active');
  });
};

/**
 * Update page title on variant change
 *
 */
thousand.controllers.handleVariantChange = function () {
  $(document).on('thousand:variant:selected', function (event, variant) {
    var $title = $('title');
    var $productName = $('.product-copy-section .product_name').first();

    if(!window.location.search){
      return;
    }
    if(!$title.attr('data-original')){
      $title.attr('data-original', $title.text().trim().replace(/[\n\t]/g, '').replace(/\s+/g, ' '));
    }
    $title.text(`${variant.options[0]} ${$title.attr('data-original')}`.trim().replace(/[\n\t]/g, '').replace(/\s+/g, ' '));

    if(!$productName.attr('data-original')){
      $productName.attr('data-original', $productName.text());
    }
    if(variant.options[0].includes('SmileyWorld')){
      $productName.text('Thousand Next | SmileyWorld® Youth Helmet');
    } else {
      $productName.text($productName.attr('data-original'));
    }
  });
}



/**
 * Controllers initialization
 *
 * Call functions which will setup controllers
 * to DOM elements (tipically). For example, you
 * can select certain DOM based on a data-attribute
 * and apply a behavior to all those selected.
 *
 * For example, jQuery Match Height plugin uses
 * this pattern: https://github.com/liabru/jquery-match-height
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */
thousand.controllers.init = function () {
  // Refactored, inherited code
  thousand.controllers.swatchTile();
  thousand.controllers.scrollTopButton();

  // New code
  thousand.controllers.smoothScroll();
  thousand.controllers.toggleTabAndScroll();
  thousand.controllers.hashLinkScroll();
  thousand.controllers.handleVariantChange();
};




// -----------------------------------------
// .....--------- Helpers  -----------------
// -----------------------------------------


thousand.helpers.Thousand180VariantImages = function (variantImageUrls, defaultColor, showImageHandler) {
  showImageHandler = showImageHandler || function () {};
  defaultColor = defaultColor || Object.keys(variantImageUrls)[0];

  var variantImagesCache = {};
  var variantImages = [];
  var currentVariantImageId = 3;
  var variantImageLastChange = null;

  var self = {};

  self.setVariant = function (color) {
    // Initialize cache
    if (!variantImagesCache[color]) {
      // Get variant images or find some others to show.
      var imageUrls = variantImageUrls[color] || variantImageUrls[defaultColor];
      if (typeof imageUrls  !== "undefined"){
      // Create images from urls
      variantImagesCache[color] = imageUrls.map(function (url, i) {
        var image = new Image(265, 406);
        image.src = url;
        return image;
      });
      }
    }

    variantImages = variantImagesCache[color];

    self.showImage(currentVariantImageId);
  };

  self.getImage = function (i) {
    // Obtain the image at "i" position, or retrieve the last one.
    return variantImages[i] || variantImages[variantImages.length - 1];
  }

  self.getImageUrl = function (i) {
    return self.getImage(i).src;
  }

  self.showImage = function (i) {
    var url = self.getImageUrl(i);

    showImageHandler(url, i);

    currentVariantImageId = i;
    variantImageLastChange = Date.now();
    return variantImageLastChange;
  }

  // Add a timeout to verify if some other image
  // was chosen. Avoids flickering.
  self.showImageWithDelay = function (i) {
    var _lastChange = variantImageLastChange;

    setTimeout(function () {
      VariantImages.showImage(i);
      // If no other change was requested, show original
      if (_lastChange == variantImageLastChange) {
        VariantImages.showImage(3);
      }
    }, 50);
  }

  $(document).on('thousand:variant:selected', function (event, variant) {
    var color = thousand.utils.handlify(variant.option1);
    self.setVariant(color);
  });

  return self;
}


thousand.helpers.Thousand180VariantImagesSetup = function (initialVariant) {
  var VariantImages = new thousand.helpers.Thousand180VariantImages(
    thousand.assets.helmets.view180Images,
    initialVariant,
    function (url, i) {
      if( $('.img-180')[0] != null ) {
        	$('.img-180')[0].src = url;
      }
    }
  );

  VariantImages.setVariant(initialVariant);

  return VariantImages;
}


thousand.helpers.Thousand180VariantImagesMobileSetup = function (initialVariant) {
  var VariantImages = new thousand.helpers.Thousand180VariantImages(
    thousand.assets.helmets.view180ImagesMobile,
    initialVariant,
    function (url, i) {
      $('#sliderStatus').html(i);
      $("#img").prop("src", url);
    }
  );

  VariantImages.setVariant(initialVariant);

  $(document).on('input change', '#slider', function() {//listen to slider changes
      var v=$(this).val();//getting slider val
     VariantImages.showImage(parseInt(v) - 1)
  });

  return VariantImages
}






// -----------------------------------------
// --------- Shopify Customization ---------
// -----------------------------------------


/**
 * The following code customizes different methods from option_selection.js
 *
 * @author Ary Pablo Batista <ary@riessgroup.com>
 */


// Overrides selectVariantFromParams to use clean variant names
if(Shopify && Shopify.OptionSelectors){
  Shopify.OptionSelectors.prototype.selectVariantFromParams = function (options) {
    var variantOptions = ['color','size','style','light'];
    var variantQueryParams = [];
    $.each(variantOptions, (idx,option)=>{
      if(Shopify.urlParam(option)){
        variantQueryParams.push(Shopify.urlParam(option));
      }
    })

    if (variantQueryParams.length) {
      var variant = thousand.utils.variantFromName(this.product, variantQueryParams);
      if (!variant) {
        console.warn('no variant selected')
      }
    } else {
      console.warn('no query params')
      return;
    }

    return this.selectVariant(variant.id, options);
  };


  // TODO: Remove, used as checkpoint for debugging
  var _selectVariant = Shopify.OptionSelectors.prototype.selectVariant;
  Shopify.OptionSelectors.prototype.selectVariant = function (variantId, options) {
    return _selectVariant.call(this, variantId, options);
  };


  // Modify initDropdown behavior in a way it will try to parse
  // query parameters before using the first element in the dropdown
  // to initialize the variant selector.
  Shopify.OptionSelectors.prototype.initDropdown = function () {
    var options = { initialLoad: true };
    var self = this;
    setTimeout(function () {

      if (!self.selectVariantFromParams(options)) {
        var successDropdownSelection = self.selectVariantFromDropdown(options);

        if (!successDropdownSelection) {
          self.fireOnChangeForFirstDropdown.call(self, options);
        }
      }

    });
  };


  // Override variant change handler on Shopify.OperationSelectors to
  // write the variant name into the url instead of the ID.
  Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (variant, selector, data) {
    if (this.browserSupports()) {
      if (variant && !data.initialLoad && !data.popStateCall) {                        
        var variantQueryString = thousand.utils.variantAsQueryString(variant, thousand.utils.getCurrentProductJSON());
        history.replaceState({}, document.title, '?' + variantQueryString);
      }
    }
    thousand.callbacks.onVariantSelected(variant);
  };

}


// -----------------------------------------
// ----------- Assets    -------------------
// -----------------------------------------

thousand.assets.helmets = {

  view180ImagesMobile : {

    'carbon-black' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-1-fs-m-compressed.jpg?v=3978194509440477294',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-2-fs-m-compressed.jpg?v=11120920129559707348',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-3-fs-m-compressed.jpg?v=11911540901338772365',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-4-fs-m-compressed.jpg?v=15538048030504305771',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-5-fs-m-compressed.jpg?v=4628783015758815776',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-6-fs-m-compressed.jpg?v=7298411410480956563',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-7-fs-m-compressed.jpg?v=14000105006044400778'
    ],

    'thousand-navy' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-1-fs-m-compressed.jpg?v=10747894475087164938',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-2-fs-m-compressed.jpg?v=9184317232090799734',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-3-fs-m-compressed.jpg?v=4882684530900586287',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-4-fs-m-compressed.jpg?v=16652596186154862754',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-5-fs-m-compressed.jpg?v=5315277968181795372',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-6-fs-m-compressed.jpg?v=4892587744692025549',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-7-fs-m-compressed.jpg?v=15599861035311523258'
    ],

    'willowbrook-mint' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-1-m-compressed.jpg?v=3939763042240605198',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-2-m-compressed.jpg?v=14567044259810996457',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-3-m-compressed.jpg?v=13202916738021698607',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-4-m-compressed.jpg?v=14498825054410916711',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-5-m-compressed.jpg?v=4061780991659656399',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-6-m-compressed.jpg?v=114163858168668962',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-7-m-compressed.jpg?v=8828536834969702483'
    ],

    'speedway-creme' : [
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-1-m-compressed.jpg?v=3266005703332440631',
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-2-m-compressed.jpg?v=14913801483100538456',
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-3-m-compressed.jpg?v=5027498356925912635',
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-4-m-compressed.jpg?v=12601392003729195746',
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-5-m-compressed.jpg?v=6907457141266451569',
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-6-m-compressed.jpg?v=2073894819472947917',
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-7-m-compressed.jpg?v=12381398895283349488'
    ],

    'stealth-black' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-1-fs-m-compressed.jpg?v=4441104531634207272',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-2-fs-m-compressed.jpg?v=17715854519276258468',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-3-fs-m-compressed.jpg?v=466443169452476025',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-4-fs-m-compressed.jpg?v=18131940316709756601',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-5-fs-m-compressed.jpg?v=9113266800769845326',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-6-fs-m-compressed.jpg?v=3420015981385198757',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-7-fs-m-compressed.jpg?v=13949280738446849874'
    ],
    
    'arctic-grey' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-1-fs-m-compressed.jpg?v=15529808117749619441',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-2-fs-m-compressed.jpg?v=10522787803953799608',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-3-fs-m-compressed.jpg?v=7860419753283417846',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-4-fs-m-compressed.jpg?v=5868126217559594014',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-5-fs-m-compressed.jpg?v=6677286514125955662',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-6-fs-m-compressed.jpg?v=5843464061254639891',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-7-fs-m-compressed.jpg?v=6596768184498046193'
    ],    

    'stay-gold' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-1-fs-m-compressed.jpg?v=16562105227711655105',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-2-fs-m-compressed.jpg?v=15112209989743890761',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-3-fs-m-compressed.jpg?v=7407487340669480834',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-4-fs-m-compressed.jpg?v=9928430916588716864',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-5-fs-m-compressed.jpg?v=958259987070804374',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-6-fs-m-compressed.jpg?v=5250267450402223660',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-stay-gold-7-fs-m-compressed.jpg?v=1279472819483404373'
    ],

    'daybreak-red' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-1-fs-m-compressed.jpg?v=5433205495276189459',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-2-fs-m-compressed.jpg?v=5961192661672429194',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-3-fs-m-compressed.jpg?v=4123332819800465323',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-4-fs-m-compressed.jpg?v=2133634497328645965',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-5-fs-m-compressed.jpg?v=2941087303854154143',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-6-fs-m-compressed.jpg?v=14378027281123856739',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-7-fs-m-compressed.jpg?v=17859780383885859667'
    ],

    'gt-stripe' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-1-fs-m-compressed.jpg?v=16403116893002494708',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-2-fs-m-compressed.jpg?v=17599947032331163830',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-3-fs-m-compressed.jpg?v=778768178120853501',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-4-fs-m-compressed.jpg?v=10826597521130984600',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-5-fs-m-compressed.jpg?v=3668644705073029063',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-6-fs-m-compressed.jpg?v=3446140328509341521',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-7-fs-m-compressed.jpg?v=10791444153075046985'
    ],

    'color-blocks' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-1-m-compressed.jpg?v=13403959587218197276',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-2-m-compressed.jpg?v=9444976334622572928',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-3-m-compressed.jpg?v=14647424325955971914',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-4-m-compressed.jpg?v=4438619810614632501',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-5-m-compressed.jpg?v=10855094819715122911',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-6-m-compressed.jpg?v=4096914255889931352',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-7-m-compressed.jpg?v=9783113589819469030'
    ],

    'coral-reef' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-1-m-compressed.jpg?v=4976721658952496443',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-2-m-compressed.jpg?v=4892084449670365481',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-3-m-compressed.jpg?v=10808300312827433594',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-4-m-compressed.jpg?v=13241021706347712895',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-5-m-compressed.jpg?v=6265669218533580783',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-6-m-compressed.jpg?v=8795550764527812004',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-7-m-compressed.jpg?v=2291885320163126628'
    ],

    'memphis-movement' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-1-m-compressed.jpg?v=3816474678143758845',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-2-m-compressed.jpg?v=15561689959538092599',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-3-m-compressed.jpg?v=9392436888848083948',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-4-m-compressed.jpg?v=10797660764825927544',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-5-m-compressed.jpg?v=8459645642747043445',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-6-m-compressed.jpg?v=12740085256613567623',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-7-m-compressed.jpg?v=17336696604030769101'
    ],

    'polished-titanium' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-polished-titanium-1-fs-m-compressed.jpg?v=5533635387912423748',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-polished-titanium-2-fs-m-compressed.jpg?v=8349928042379776438',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-polished-titanium-3-fs-m-compressed.jpg?v=8355844539112214467',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-polished-titanium-4-fs-m-compressed.jpg?v=17949644446228429829',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-polished-titanium-5-fs-m-compressed.jpg?v=11676926783206345848',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-polished-titanium-6-fs-m-compressed.jpg?v=9248441406625148124',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-polished-titanium-7-fs-m-compressed.jpg?v=17741656469720454008'
    ],

    'rose-gold' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-rose-gold-1-fs-m-compressed.jpg?v=6875290799531600787',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-rose-gold-2-fs-m-compressed.jpg?v=9989518384362195891',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-rose-gold-3-fs-m-compressed.jpg?v=4792987475096923454',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-rose-gold-4-fs-m-compressed.jpg?v=3886883589734685708',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-rose-gold-5-fs-m-compressed.jpg?v=559274943695674896',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-rose-gold-6-fs-m-compressed.jpg?v=14705825173469581543',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-rose-gold-7-fs-m-compressed.jpg?v=2455752212737713294'
    ],
    'coastal-blue' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-1-m-compressed.jpg?v=4070895935575583996',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-2-m-compressed.jpg?v=16294327320362332039',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-3-m-compressed.jpg?v=1332738243303009909',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-4-m-compressed.jpg?v=13586556785816057763',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-5-m-compressed.jpg?v=8045627662757400918',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-6-m-compressed.jpg?v=9895572786734972089',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-7-m-compressed.jpg?v=2685412542091731558'
    ],

    'terra-cotta' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-1-m-compressed.jpg?v=11629570074414625747',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-2-m-compressed.jpg?v=15166616822175244583',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-3-m-compressed.jpg?v=14474010544378083648',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-4-m-compressed.jpg?v=13143594828150196847',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-5-m-compressed.jpg?v=14141653745920511369',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-6-m-compressed.jpg?v=5040491447641996448',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-7-m-compressed.jpg?v=3355854009063675078'
    ],

    'jacaranda-purple' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-1-m-compressed.jpg?v=10563293703516454037',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-2-m-compressed.jpg?v=9100293345511140474',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-3-m-compressed.jpg?v=8261784106136098931',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-4-m-compressed.jpg?v=11245317888005199303',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-5-m-compressed.jpg?v=13736608612153273736',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-6-m-compressed.jpg?v=4110697941176634076',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-7-m-compressed.jpg?v=6232823144889429352'
    ],

    'so-silver' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-So-Silver-1-m-compressed.jpg?v=469467512505877547',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-So-Silver-2-m-compressed.jpg?v=2456886203104572422',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-So-Silver-3-m-compressed.jpg?v=3077007014820730834',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-So-Silver-4-m-compressed.jpg?v=12810814592159888263',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-So-Silver-5-m-compressed.jpg?v=2660686010851179362',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-So-Silver-6-m-compressed.jpg?v=430323154948737458',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-So-Silver-7-m-compressed.jpg?v=10627720867573837044'
    ]
  },

  view180Images: {
    'speedway-creme' : [
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-1-compressed.jpg?v=14912332135925412125',
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-2-compressed.jpg?v=17300914988714343689',
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-3-compressed.jpg?v=9724586526003668175',
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-4-compressed.jpg?v=16057879643346260045',
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-5-compressed.jpg?v=10964605139349569536',
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-6-compressed.jpg?v=1708805421890803127',
        '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-speedway-creme-fs-7-compressed.jpg?v=13389066486416049085'
    ],

    'willowbrook-mint' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-1-compressed.jpg?v=664343551238618386',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-2-compressed.jpg?v=1666604066033886949',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-3-compressed.jpg?v=4652241477816667902',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-4-compressed.jpg?v=969959218535167063',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-5-compressed.jpg?v=9505802267767774502',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-6-compressed.jpg?v=4995078812002836093',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-willowbrook-mint-fs-7-compressed.jpg?v=8359935973120728050'
    ],

    'carbon-black' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-1-fs-compressed.jpg?v=6861488230559333684',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-2-fs-compressed.jpg?v=2348562114441554497',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-3-fs-compressed.jpg?v=12836169565805451174',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-4-fs-compressed.jpg?v=13464569289326183249',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-5-fs-compressed.jpg?v=3262667470836209876',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-6-fs-compressed.jpg?v=3074935670099441101',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-carbon-black-7-fs-compressed.jpg?v=13573032989467731008'
    ],

    'thousand-navy' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-1-fs-compressed.jpg?v=6640918657673861371',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-2-fs-compressed.jpg?v=10028375347902272821',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-3-fs-compressed.jpg?v=15264815997098021622',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-4-fs-compressed.jpg?v=7978564128809486606',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-5-fs-compressed.jpg?v=9471648950991348974',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-6-fs-compressed.jpg?v=11348553392837886262',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-navy-7-fs-compressed.jpg?v=1487324101315572802'
    ],
    
    'stealth-black' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-1-fs-compressed.jpg?v=17584403940802672161',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-2-fs-compressed.jpg?v=17869589229927790061',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-3-fs-compressed.jpg?v=146255084044397380',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-4-fs-compressed.jpg?v=16650065570183486109',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-5-fs-compressed.jpg?v=17216698149616935590',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-6-fs-compressed.jpg?v=9487169502364852110',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stealth-black-7-fs-compressed.jpg?v=5692777900366941317'
    ],    
    
    'arctic-grey' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-1-fs-compressed.jpg?v=13048814461220976919',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-2-fs-compressed.jpg?v=33587665676471130',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-3-fs-compressed.jpg?v=16563643757353241179',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-4-fs-compressed.jpg?v=8567387845195318187',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-5-fs-compressed.jpg?v=10162730090475151939',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-6-fs-compressed.jpg?v=3888852152710684351',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-arctic-grey-7-fs-compressed.jpg?v=10192946474289626687'
    ],    

    'stay-gold' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-1-compressed.jpg?v=4947088598728546497',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-2-compressed.jpg?v=6118393093174687812',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-3-compressed.jpg?v=13968003208566550890',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-4-compressed.jpg?v=8355494648554685769',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-5-compressed.jpg?v=6149028421538522612',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-6-compressed.jpg?v=6391669015194803368',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-stay-gold-fs-7-compressed.jpg?v=10240718894025757249'
    ],

    'daybreak-red' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-1-fs-compressed.jpg?v=2634824650418158343',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-2-fs-compressed.jpg?v=1791135524768574152',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-3-fs-compressed.jpg?v=13333312974718482810',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-4-fs-compressed.jpg?v=9021818307760975976',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-5-fs-compressed.jpg?v=11125011581068947967',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-6-fs-compressed.jpg?v=18304302510834676119',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-daybreak-red-7-fs-compressed.jpg?v=5743909905954952503'
    ],

    'gt-stripe' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-1-fs-compressed.jpg?v=14243677187226390640',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-2-fs-compressed.jpg?v=15605399825942949117',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-3-fs-compressed.jpg?v=2320117911152350880',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-4-fs-compressed.jpg?v=12997941497480461451',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-5-fs-compressed.jpg?v=8734536683307849692',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-6-fs-compressed.jpg?v=2118349533679771478',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-gt-stripe-7-fs-compressed.jpg?v=17390503251947089408'
    ],

    'color-blocks' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-1-compressed.jpg?v=12277244401161718026',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-2-compressed.jpg?v=10442819664129765585',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-3-compressed.jpg?v=6972431496607918878',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-4-compressed.jpg?v=4268569408181007508',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-5-compressed.jpg?v=14570395706730237165',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-6-compressed.jpg?v=6827395427985722965',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-color-blocks-7-compressed.jpg?v=3406509410304181088'
    ],

    'coral-reef' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-1-compressed.jpg?v=12720499898876882902',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-2-compressed.jpg?v=9049228919701643015',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-3-compressed.jpg?v=12041552761018521418',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-4-compressed.jpg?v=18239654859064637233',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-5-compressed.jpg?v=11385415676714149352',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-6-compressed.jpg?v=11529879278472437176',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-coral-reef-7-compressed.jpg?v=14377552362104341391'
    ],

    'memphis-movement' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-1-compressed.jpg?v=7156063639244979407',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-2-compressed.jpg?v=16382468703976226824',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-3-compressed.jpg?v=10493710152360986952',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-4-compressed.jpg?v=9902217242438976905',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-5-compressed.jpg?v=6755242034991307606',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-6-compressed.jpg?v=14763683270696148555',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-poketo-memphis-movement-7-compressed.jpg?v=5052696295662515144'
    ],

    'rose-gold' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-1-fs-compressed.jpg?v=4398251538016292809',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-2-fs-compressed.jpg?v=2277058519719365297',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-3-fs-compressed.jpg?v=6129183590745947306',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-4-fs-compressed.jpg?v=15892059827290126396',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-5-fs-compressed.jpg?v=2567342940806843543',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-6-fs-compressed.jpg?v=14737059335307387952',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-thousand-rose-gold-7-fs-compressed.jpg?v=15882208573474697476'
    ],
    
    'polished-titanium' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-PolishedTitanium-1-fs-compressed.jpg?v=11706745098130269794',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-PolishedTitanium-2-fs-compressed.jpg?v=2629083979631572451',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-PolishedTitanium-3-fs-compressed.jpg?v=10168290152705443309',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-PolishedTitanium-4-fs-compressed.jpg?v=6477314886982006260',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-PolishedTitanium-5-fs-compressed.jpg?v=14216722462387150919',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-PolishedTitanium-6-fs-compressed.jpg?v=4559143022259269552',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-PolishedTitanium-7-fs-compressed.jpg?v=10876122838020755604'
    ],

    'coastal-blue' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-1-compressed.jpg?v=3392581003900585922',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-2-compressed.jpg?v=8947348489079324604',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-3-compressed.jpg?v=12471420081953120922',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-4-compressed.jpg?v=5215599076243943819',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-5-compressed.jpg?v=495675759172083479',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-6-compressed.jpg?v=7207933780878903059',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-coastal-blue-fs-7-compressed.jpg?v=16082054339196536038'
    ],

    'terra-cotta' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-1-compressed.jpg?v=14374988625331872781',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-2-compressed.jpg?v=7257186878771116578',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-3-compressed.jpg?v=8030039782382856902',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-4-compressed.jpg?v=6400749794437410829',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-5-compressed.jpg?v=8682850095114818722',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-6-compressed.jpg?v=16657472544012088424',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-terracotta-fs-7-compressed.jpg?v=2796906741492251304'
    ],

    'jacaranda-purple' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-1.png?v=10452236345160730596',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-2.png?v=9287390787948639326',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-3.png?v=1002979939219918665',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-4.png?v=818865151616966507',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-5.png?v=11209723713980763073',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-6.png?v=11524421480819509075',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-jacaranda-purple-7.png?v=13761620207337518267'
    ],

    'so-silver' : [
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-D-So-Silver-1.png?v=4396742433727306150',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-D-So-Silver-2.png?v=6644696163276466660',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-D-So-Silver-3.png?v=2800468325853840075',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-D-So-Silver-4.png?v=9060900688417265484',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-D-So-Silver-5.png?v=18106624398122929010',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-D-So-Silver-6.png?v=18130873264568022074',
      '//www.explorethousand.com/cdn/shop/files/thousand-helmet-180-D-So-Silver-7.png?v=15151069112955227512'
    ]
  }
}




// -----------------------------------------
// ---------------- Main -------------------
// -----------------------------------------


/**
 * Execute scripts without waiting for events.
 * Commands here will execute when the file is
 * evaluated.
 **/
thousand.start = function () {
  thousand.callbacks.init();
};


/**
 * Handle document load
 **/
thousand.load = function () {
  $(".banner-section").each(function(i,e){
    $(e).find(".copy-text").fadeIn();
  });
};


/**
 * Handle document ready.
 * Initialize Thousand Helmet scripts.
 **/
thousand.init = function () {
  thousand.controllers.init();
};


// Call scripts
$(document).ready(thousand.init.bind(thousand));
$(window).on('load', thousand.load.bind(thousand));
thousand.start();

}());


  /**
  *Getting user location and setting it in cookie
  *
  */

    $(document).on('thousand:variant:selected', function(e, data){
    	$('.covid_error').remove();
       		if(inventryByLocation.hasOwnProperty(data.id)){
         		if($.inArray(user_loc_country,restricted_country) !== -1){
            		$('.purchase-details__buttons .add_to_cart').prop('disabled', true);
            		$('.purchase-details__buttons .add_to_cart').addClass('disabled');
            		$('.purchase-details__buttons .add_to_cart span').text('Sold Out');
           			$('.purchase-details__buttons .add_to_cart').after('<p class="letters__error covid_error">Due to the recent COVID lockdown, we are temporarily unable to ship to the UK. Please check back later or contact us for more info.</p>');
           			$('body').addClass('is-out-of-stock'); 
         		} else if ( inventryByLocation[data.id][user_loc] < 1 ) {
            		$('.purchase-details__buttons .add_to_cart').prop('disabled', true);
            		$('.purchase-details__buttons .add_to_cart').addClass('disabled');
            		$('.purchase-details__buttons .add_to_cart span').text('Sold Out');
           			$('body').addClass('is-out-of-stock'); 
         		} else {
            		$('.qty-input input').attr('data-max' , inventryByLocation[data.id][user_loc] );
            		$('.qty-input input').val(1);
            		$('.purchase-details__buttons .add_to_cart').prop('disabled', false);
            		$('.purchase-details__buttons .add_to_cart').removeClass('disabled');
            		$('.purchase-details__buttons .add_to_cart span').text('Add to cart');
           			$('body').removeClass('is-out-of-stock'); 
         		}
       		}
        initCustomNotify(data.id);
    });


	$(document).on( 'keyup' , '.qty-input input'  , function() {
  		$('.warning').remove();
   		var user_input = this.value;
    	var max_qty = $(this).attr('data-max');
  		var $addToCartBtn = $('.shopify-product-form').find('.add_to_cart');
  		
    	if( parseInt(user_input) > parseInt(max_qty) ) {
      		var warning = '<p class="warning animated bounceIn">Only '+max_qty+' products left.</p>';
      		$addToCartBtn.after(warning);
      		$addToCartBtn.attr('disabled','disabled').removeClass('disabled is--sending');
      		$addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn'); 
      		$(this).val( max_qty );
    	} else {
      		$addToCartBtn.removeAttr('disabled').removeClass('disabled is--sending');
    	}
  	});

  	

	$(document).on( 'click' , '.qty-input .js-change-quantity'  , function() {
      	$('.warning').remove();
      	var user_i = $('.qty-input input');
      	var user_input = user_i.val();
      	var max_qty = user_i.attr('data-max');
      	var $addToCartBtn = jQuery('.shopify-product-form').find('.add_to_cart');
      	if( parseInt(user_input) > parseInt(max_qty) ) {
          	var warning = '<p class="warning animated bounceIn">Only '+max_qty+' products left.</p>';
          	$addToCartBtn.after(warning);
          	$addToCartBtn.attr('disabled','disabled').removeClass('disabled is--sending');
          	$addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn'); 
          	$(user_i).val( max_qty );
      	} else {
          	$addToCartBtn.removeAttr('disabled').removeClass('disabled is--sending');
      	}
    });

	
	if( user_loc=='eur' ) {
      if(jQuery('.product_name').text().indexOf('Light')>0){
        jQuery('.swatch-type-light input[data-variant-name="Set"]').remove();
        jQuery('.swatch-type-light div[data-value="Set"]').remove();
        var check_light = Shopify.urlParam('light');
        if(check_light == null || check_light == 'set'){
          setTimeout(function () {
            jQuery('.swatch-type-light div[data-value="Front"] label').trigger('click');
          }, 1000)
        }
        
        // setInterval(function () {
        //   jQuery('.swatch-type-light div[data-value="Front"] label').trigger('click');
        // }, 1000);

        
        var product_data = jQuery('.product_form').data('product');
        product_data.variants = product_data.variants.filter(function(elem) {  
          return elem.option2 === 'Front' || 'Rear'; 
        }); 
        jQuery('.product_form').data('product',product_data);
      }
      	if($.inArray(user_loc_country,restricted_country) !== -1){
  			$('.promo_banner .promo_banner__content').html('<p>Due to the recent COVID lockdown, we are temporarily unable to ship to the UK. Please check back later or contact us for more info.</p>');
    	}
        if($('.free_shipping').length){
            $('.free_shipping').remove();
        }
	}

    function whenAvailable(name) {
        var interval = 10; // ms
        window.setTimeout(function() {
            if (window[name]) {
              if(user_loc=='usa'){
                var product_info=$('.product_form').data('product');
                var new_variants_obj = [];
                $.each(product_info.variants,function(i,v){
                    if(inventryByLocation.hasOwnProperty(v.id) && inventryByLocation[v.id][user_loc] < 1){
                        new_variants_obj.push(v);
                    }
                });
                SI.popup.variants = new_variants_obj;
                if (typeof SI.popup.form == 'undefined') {
                  SI.popup.createUI();
                }
                $(document).on('click',".custom-notify-popup", function() {
                   SIPopover.show({'variantId': globalVariantID});
                });
                initCustomNotify(globalVariantID);
              }
            } else {
                whenAvailable(name);
            }
        }, interval);
    }


	whenAvailable('SIPopover');

    function initCustomNotify(variant_id){
      if(user_loc=='usa'){
        $('.custom-notify-wrap, .custom-crosssell-wrap').remove();
        if(inventryByLocation.hasOwnProperty(variant_id) && inventryByLocation[variant_id][user_loc]<1){
          if(thousand.globals.currentProductJSON.handle === 'bike-helmet'){
            inith2Upsell(variant_id);
            return;
          }
          if(!$('.custom-notify-wrap').length){
            if (variant_id == '39962217414703' || variant_id == '39403505516591'){
              $('.custom-notify-wrap').remove();
            } else {
              $('form.shopify-product-form .purchase-details__buttons').after('<style>.custom-notify-wrap{padding-top:12px;cursor:pointer!important;} .custom-notify-wrap:hover, .custom-notify-wrap:focus {color:#FA4616 ;}</style><div class="custom-notify-wrap"><span class="custom-notify-popup">NOTIFY ME WHEN AVAILABLE ></span></div>');
            }
          }
        }else{
          	$('.custom-notify-wrap').remove();
        }
      }
    }

    function inith2Upsell(variant_id){
      const h1OnlyVariants = [
        // Jacaranda Purp
        40850521391151, 40850521423919, 40850521456687,
        // Arctic Grey
        31574135177263, 31574135210031, 31574135242799,
        // Polished Tita
        31683588653103, 31683591012399, 31683592552495,
        // Rose Gold
        31683573645359, 31683576102959, 31683577118767,
        // Stay Gold
        31574135570479, 31574135603247, 31574135636015,
        // Daybreak Red
        31574135668783, 31574135701551, 31574135734319
      ];
      
      if(inventryByLocation.hasOwnProperty(variant_id) && inventryByLocation[variant_id][user_loc]<1){
        if (!h1OnlyVariants.includes(variant_id)){
          // crosssell to h2 same colorway if exists
          const h2URL = window.location.href.replace('bike-helmet', 'bike-helmet-2');
          $('form.shopify-product-form .purchase-details__buttons').after(`<style>.custom-crosssell-wrap{padding-top:12px;cursor:pointer!important;} .custom-crosssell-wrap:hover, .custom-crosssell-wrap:focus {color:#FA4616 ;}</style><div class="custom-crosssell-wrap"><a href="${h2URL}" class="custom-crosssell">AVAILABLE ONLY IN HERITAGE 2.0 ></a></div>`);
        }
      }
    }



    /*comparison page js*/
    
	$(document).ready(function(){
      	
      	$(window).scroll(function() {
        	if ( $(window).scrollTop() >= 450 ) {
               $('.tm-desktop-content .comparison-top-content').addClass("sticky");
         	}
        	if ( $(window).scrollTop() == 0) {
               $('.tm-desktop-content .comparison-top-content').removeClass('sticky');
         	}
    	});

  
  
  		$(".adult-product").show();
   		$(".kids").hide();
  		$("#adult").addClass('active');

        //for tabs'
        $('#adult').click(function(e){
            e.preventDefault();
            $(".adult-product").show();
            $(".kids").hide();
            $("#adult").addClass('active');
            $("#kids").removeClass('active');
        });

        $('#kids').click(function(e){
            e.preventDefault(); 
            $(".kids").show();
            $(".adult-product").hide();
            $("#kids").addClass('active');
            $("#adult").removeClass('active');
        });

    	var header = $(".tabs-unlinked.nav-categories , .comparison-mobile-tab .comparison-top-content");

	});
  
	/*end comparison page js*/

	$( document ).ready(function() {
		var menu_items = {
			'tm-mega-menu-1': [
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/files/thsd-nav-lifestyle-h2-5_medium.jpg?v=1774299966', displayImg: 'https://www.explorethousand.com/cdn/shop/files/1Thsd_H2_Profile_TerraCotta_800x_641e47ea-d818-4aad-9cc9-3270e0d3ab31_400x.jpg?v=1680578535', title: 'Heritage 2.0', des: 'Heritage 2.0' },
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/files/thsd-nav-lifestyle-chpt-5_medium.jpg?v=1774299966', displayImg: 'https://cdn.shopify.com/s/files/1/0836/6919/files/thousand-chapter-Profile-RacerBlack_400x_434df705-4a8d-43ab-a65a-9075dbcbbebf.jpg?v=1774304902', title: 'Chapter', des: 'Chapter' },
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/files/thsd-nav-lifestyle-chpt_-2_medium.jpg?v=1774299966', displayImg: 'https://www.explorethousand.com/cdn/shop/files/thousand-helmet-chpt_-profile-Midnight-Blue_222db929-1985-4335-9548-657c50b302f5_400x.png?v=1754426512', title: 'Chapter+', des: 'Chapter+ Limited' },
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/files/thsd-nav-lifestyle-toddler-1_medium.jpg?v=1774299966', displayImg: 'https://www.explorethousand.com/cdn/shop/files/thousand-toddler-helmet-Green-Dream--5_8d954ccb-82e5-4de2-97c2-24e25b31d3a6_400x.jpg?v=1710203432', title: 'Toddler', des: 'Toddler' },
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/files/thsd-nav-lifestyle-kids-1_medium.jpg?v=1774299966', displayImg: 'https://www.explorethousand.com/cdn/shop/files/ThsdJR-helmet-blazingblue-1_400x.jpg?v=1618599139', title: 'Kids', des: 'Kids' },
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/files/thsd-nav-lifestyle-next-2_medium.jpg?v=1774299966', displayImg: 'https://thousand-helmets.myshopify.com/cdn/shop/files/thsd-helm-next-PacificTide-prof-in_800x.jpg?v=1774028460', title: 'Next', des: 'Next' },
			],
			'tm-mega-menu-2': [
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/files/thousand-PennentBell-Brass-1.jpg?v=1618599138', title: 'Bike Bells', des: 'Bike Bells' },
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/files/thousand-gloves-little-5-1.jpg?v=1618599137', title: 'Bike Gloves', des: 'Bike Gloves' },
			{ img: 'https://www.explorethousand.com/cdn/shop/files/tvlr2-set-hero_800x.jpg?v=1699290541', title: 'Bike Lights', des: 'Bike Lights' },
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/products/Thsd_Locks_U-lock_1_800x.jpg?v=1657738204', title: 'Bike Locks', des: 'Bike Locks' },
			{ img: 'https://www.explorethousand.com/cdn/shop/files/thsd-pdp-xbh-black-1_800x.jpg?v=1668552119', title: 'Crossbody Handlebar Bag', des: 'Crossbody Handlebar Bag' },
			{ img: 'https://explorethousand.com/cdn/shop/files/THO_00223_800x.jpg?v=1727212252', title: 'Thousand x Rareform Crossbody Handlebar Bag', des: 'Thousand x Rareform Crossbody Handlebar Bag' },
			{ img: 'https://www.explorethousand.com/cdn/shop/products/Thsd_PDP_HO22-Gloves-1_800x.jpg?v=1697213023', title: 'Winter Riding Gear', des: 'Winter Riding Gear' },
			{ img: 'https://www.explorethousand.com/cdn/shop/files/Thsd_PDP_UpcycledTote-1_800x.jpg?v=1689783091', title: 'Upcycled Tote Bag', des: 'Upcycled Tote Bag' },
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/files/ThsdJR-sticker-JRactivist-1.jpg?v=1618599139', title: 'Helmet Stickers', des: 'Helmet Stickers' },
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/files/thousand-chapter-visor_DayglowYellow.jpg?v=1618599138', title: 'Helmet Visors', des: 'Helmet Visors' },
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/files/1_800x.jpg?v=1687904030', title: 'Magnetic Helmet Light', des: 'Magnetic Helmet Light' },
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/files/ThsdJR-bell-letsridewhite-1.jpg?v=1618599137', title: 'Kids Bike Bells', des: 'Kids Bike Bells' },
			{ img: 'https://cdn.shopify.com/s/files/1/0836/6919/files/ThsdJR-sticker-JRactivist-1.jpg?v=1618599139', title: 'Kids Helmet Stickers', des: 'Kids Helmet Stickers' },
			]
		};

		// desktop hover image swap
		$('.main_nav .dropdown_column__menu ul:not(.dropdown_title) li').on('mouseenter', function() {
			var $menu = $(this).closest('.tm-mega-menu-1, .tm-mega-menu-2');
			var menuKey = $menu.hasClass('tm-mega-menu-1') ? 'tm-mega-menu-1' : 'tm-mega-menu-2';
			var items = menu_items[menuKey];
			var index = $menu.find('.dropdown_column__menu ul:not(.dropdown_title) li').index(this);
			var item = items[index];
			if (!item) return;

			$menu.find('.tm-image-change .image-element__wrap').html('<img src="' + item.img + '" class="transition--fade-in lazyautosizes lazyloaded">');
			$menu.find('.tm-image-change .mega-menu__image-caption').removeClass('hidden-desktop').text(item.title);
			$menu.find('.tm-image-change .mega-menu__image-description').text(item.des);
		});

		// desktop: prepend images to helmet nav links
		$('.main_nav .tm-mega-menu-1 .dropdown_column__menu ul:not(.dropdown_title) li').each(function(index) {
			var item = menu_items['tm-mega-menu-1'][index];
			if (!item) return;
			$(this).find('a').prepend('<img src="' + item.displayImg + '" class="transition--fade-in lazyautosizes lazyloaded">');
		});

		// mobile: hide row title links and prepend images across both rows
		var $mobileHelmetRows = $('[data-mobile-dropdown="helmets"] .mobile-mega-menu_block.sublink');
		$mobileHelmetRows.find('> a').hide();

		var mobileIndex = 0;
		$mobileHelmetRows.each(function() {
			$(this).find('ul li').each(function() {
			var item = menu_items['tm-mega-menu-1'][mobileIndex];
			if (!item) return;
			$(this).find('a').prepend('<img src="' + item.displayImg + '" class="transition--fade-in lazyautosizes lazyloaded">');
			mobileIndex++;
			});
		});

	});

	$( document ).ready(function() {
		var comp_options = {
			heritage: {
			'polished-titanium' :{'price':'$89','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/silver_bike_helmet_001_600x.jpg','link':'https://www.explorethousand.com/products/bike-helmet?color=polished-titanium&size=small'},
			'rose-gold' :{'price':'$89','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/rose_gold_bike_helmet_001_600x.jpg','link':'https://www.explorethousand.com/products/bike-helmet?color=rose-gold&size=small'},
			'stay-gold' :{'price':'$89','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/gold_bike_helmet_001_600x.jpg','link':'https://www.explorethousand.com/products/bike-helmet?color=stay-gold&size=small'},
			'thousand-navy' :{'price':'$89','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/blue_bike_helmet_001_600x.jpg','link':'https://www.explorethousand.com/products/bike-helmet?color=thousand-navy&size=small'},
			'carbon-black' :{'price':'$89','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/black_bike_helmet_001_600x.jpg','link':'https://www.explorethousand.com/products/bike-helmet?color=carbon-black&size=small'},
			'stealth-black' :{'price':'$89','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/black_bike_helmet_1_001_600x.jpg','link':'https://www.explorethousand.com/products/bike-helmet?color=stealth-black&size=small'},
			'coastal-blue' :{'price':'$89','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/thousand-helmet-coastal-blue-1_600x.jpg','link':'https://www.explorethousand.com/products/bike-helmet?color=coastal-blue&size=small'},
			'terra-cotta' :{'price':'$89','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/thousand-helmet-terra-cotta-1_600x.jpg','link':'https://www.explorethousand.com/products/bike-helmet?color=terra-cotta&size=small'},
			'daybreak-red' :{'price':'$89','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/red_bike_helmet_001_600x.jpg','link':'https://www.explorethousand.com/products/bike-helmet?color=daybreak-red&size=small'},
			'speedway-creme' :{'price':'$89','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/retro_bike_helmet_001_600x.jpg','link':'https://www.explorethousand.com/products/bike-helmet?color=speedway-creme&size=small'},
			'arctic-grey' :{'price':'$89','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/grey_bike_helmet_001_600x.jpg','link':'https://www.explorethousand.com/products/bike-helmet?color=arctic-grey&size=small'},
			'willowbrook-mint' :{'price':'$89','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/green_bike_helmet_001_600x.jpg','link':'https://www.explorethousand.com/products/bike-helmet?color=willowbrook-mint&size=small'},
			},
			mips: {
			'club-navy' :{'price':'$135','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/Blue_MIPS_Helmet_010_600x.jpg','link':'https://www.explorethousand.com/products/mips-helmet?color=club-navy&size=small'},
			'racer-black' :{'price':'$135','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/Black_MIPS_Helmet_010_600x.jpg','link':'https://www.explorethousand.com/products/mips-helmet?color=racer-black&size=small'},
			'supermoon-white' :{'price':'$135','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/White_MIPS_Helmet_010_600x.jpg','link':'https://www.explorethousand.com/products/mips-helmet?color=supermoon-white&size=small'},

			},
			kids: {
			'power-pink' :{'price':'$60','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/ThsdJR-helmet-powerpink-1_600x.jpg','link':'https://www.explorethousand.com/products/kids-helmet?color=power-pink&size=extra-small'},
			'blazing-blue' :{'price':'$60','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/ThsdJR-helmet-blazingblue-1_600x.jpg','link':'https://www.explorethousand.com/products/kids-helmet?color=blazing-blue&size=extra-small'},
			'going-green' :{'price':'$60','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/ThsdJR-helmet-goinggreen-1_600x.jpg','link':'https://www.explorethousand.com/products/kids-helmet?color=going-green&size=extra-small'},
			'standout-sparkle' :{'price':'$60','image':'https://cdn.shopify.com/s/files/1/0836/6919/products/ThsdJR-helmet-standoutsparkle-1_600x.jpg','link':'https://www.explorethousand.com/products/kids-helmet?color=standout-sparkle&size=extra-small'}
			}
		}

		$(document).on('click','.ths-color-select .tm-color-option', function(){
		if(!$(this).hasClass('current-color')){
			var ptype = $(this).data('ptype');
			var cname = $(this).data('cname');
			$(this).parent('.ths-color-select').find('.tm-color-option.current-color').removeClass('current-color');
			$(this).addClass('current-color');
			$('.'+ptype+'-info-header img').attr('src',comp_options[ptype][cname].image);
			$('.'+ptype+'-info-header .tm-ths-product-price p').text(comp_options[ptype][cname].price);
			$('.'+ptype+'-info-header a.book-btn').attr('href',comp_options[ptype][cname].link);
			$('.'+ptype+'-info-content a.book-btn').attr('href',comp_options[ptype][cname].link);
			$('.'+ptype+'-info-header a.book-btn-1').attr('href',comp_options[ptype][cname].link);
			$('.'+ptype+'-info-content a.book-btn-1').attr('href',comp_options[ptype][cname].link);
		}
		})

		$('.ths-color-select').find('.tm-color-option:first').trigger('click');

		var $sticky = $('.comparison-mobile-tab .comparison-top-content');
		var $stickyrStopper = $('.stop-sticky');
		if (!!$sticky.offset()) { // make sure ".sticky" element exists
		var generalSidebarHeight = $sticky.innerHeight();
		var stickyTop = $sticky.offset().top;
		var stickOffset = 0;
		var stickyStopperPosition = $stickyrStopper.offset().top;
		var stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset + 500;
		var diff = stopPoint + stickOffset;

		$(window).scroll(function(){ // scroll event
			var windowTop = $(window).scrollTop(); // returns number
			if (stopPoint < windowTop) {
			$sticky.removeClass('fixed');
			} else if (stickyTop < windowTop+stickOffset) {
			$sticky.addClass('fixed');
			} else {
			$sticky.removeClass('fixed');
			}
		});
		}

	});

    function mobileCheck() {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }

    jQuery(document).on("click", ".mips-faq .js-accordion-title", function(e) {
        e.preventDefault();
        var currentIsActive = jQuery(this).hasClass('is-active');
        jQuery(this).closest('.tabs').find('.tab-label').removeClass('is-active');
        jQuery(this).closest('.tabs').find('.tab-content').removeClass('is-active');
        if(currentIsActive == false) {
            jQuery(this).addClass('is-active');
            jQuery(this).next('.tab-content').addClass('is-active');
        }
     });

    (function () {
      if (typeof MutationObserver === 'undefined') {
          return;
      }
      var fixFontDisplay = function () {
          // inject font-display option into typekit fonts
          var styles = document.getElementsByTagName('style');
          for (var i = 0; i < styles.length; i++) {
              if (
                  styles[i].innerText
                  && styles[i].innerText.indexOf('alternate-gothic-no-2-d') !== -1
                  && styles[i].innerText.indexOf('@font-face{font-display:swap;') === -1
              ) {
                  styles[i].innerText = styles[i].innerText
                          .split('@font-face{').join('@font-face{font-display:swap;');
              }
          }
      };
      var observer = new MutationObserver(function (mutationsList, observer) {
          for (var i = 0; i < mutationsList.length; i++) {
              fixFontDisplay();
          }
      });
      observer.observe(
          document.getElementsByTagName('head')[0],
          {attributes: false, childList: true, subtree: false}
      );
      window.fixFontObserver = observer;
  })();
 

 $(document).ready(function(){  
   	  var productNames = $('h1.product_name').text();
   	  const queryString = window.location.search;
  	  const urlParams = new URLSearchParams(queryString);
  	  const color = urlParams.get('color');
      const style = urlParams.get('style');
   if (productNames == 'Chapter MIPS HelmetChapter MIPS Helmet'){      
   	if (color == 'chpt3-x-thousand-barrivell'){
      $('h1.product_name').text('chpt3 x thousand barrivell');  
   } else if (color == 'gear-patrol-x-thousand'){
       $('h1.product_name').text('gear patrol x thousand');     
   }
   if (style == 'bullitt'){
      $(".block__image_with_text:nth-child(2)").css({'display':'none'});
     } else {
       $(".block__image_with_text:nth-child(2)").css({'display':'block'});
     };
    $('.swatch-element.color').click(function(){
        if($(this).attr('data-id') == '39403505057839'){
            var colorName = $(this).attr('data-value'); 
            $(".product-info__description p").text(function () {
    		return $(this).text().replace("Engineered for performance, the Chapter Collection integrates elevated utility into your daily riding uniform to always keep you moving forward.",
            "We've teamed up with CHPT3 to bring you the limited edition Barrivell Chapter helmet. Inspired by the architecture and history of Girona, the CHPT3 x Thousand Chapter helmet features an homage to the Barri Vell neighborhood's stone stairs, archways, and streets."); 
				});
            $('h1.product_name').text(colorName);
        }else if ($(this).attr('data-id') == '39962217316399'){ 
           var colorName = $(this).attr('data-value'); 
            $('h1.product_name').text(colorName);
            $(".product-info__description p").text(function () {
    		return $(this).text().replace("Engineered for performance, the Chapter Collection integrates elevated utility into your daily riding uniform to always keep you moving forward.",
            "Our limited edition Thousand x Gear Patrol Chapter helmet is inspired by New York's cycling community – from commuters and messengers to racers and sightseers. Each helmet comes with a tonal Gear Patrol decal and a unique, custom visor that is hand-painted in California."); 
				});
        }else {
            $('h1.product_name').text('Chapter MIPS Helmet');
            $(".product-info__description p").text("Engineered for performance, the Chapter Collection integrates elevated utility into your daily riding uniform to always keep you moving forward.");
        }
    });
   } else if (productNames == 'Bike GlovesBike Gloves'){       
   $('.swatch-element').click(function(){
        if($(this).attr('data-id') == '31680495157295'){
          $(".block__image_with_text:nth-child(2)").css({'display':'none'});
        } else {
          $(".block__image_with_text:nth-child(2)").css({'display':'block'});
        };
	});
   }  
 });
 

// Complete your kit js for cart element
	// on click plus buttton in the complete your order element   
	$(document).on('click', 'a.blue_plus', function(){
      
        let product_id 	= 	$(this).data('productid');
        var parent_div  = 	$(this).parents('.complete-kit-sec').find(".min-products-detail-" + product_id);
        $( parent_div ).show();
        let number_opts = $( parent_div ).find('.product-options').length;
        let varient_id = '';
        let sold_out = false;
        let all_varients = $( parent_div ).find(".min-product-variants-"+ product_id ).data('varients') ;
       	if( isJson( all_varients )  ) {
       		all_varients = JSON.parse( JSON.parse( all_varients ) );
       	}
      	if( number_opts == 1 ){
           	varient_id 	=  $( parent_div ).find('.product-options').find('input').first().data('id');
           	sold_out = ( $( parent_div ).find('.product-options').find('input').first().hasClass('soldout') ) ? true : false;
           
           	let varient_name	=  	$( parent_div ).find('.product-options').find('input').first().data('value');
            let type 			= 	$( parent_div ).find('.product-options').find('.option_title .swatch-type').text();
           
           	if( type == 'Style' || type == 'style' ) {
                 $(parent_div).find('.product-options').find('.option_title .current-style-min').text(varient_name);
            } else if ( type == 'Color' || type == 'color' ) {
                 $(parent_div).find('.product-options').find('.option_title .current-color-min').text(varient_name);
            } else if ( type == 'Size' || type == 'size' ) {
                 $(parent_div).find('.product-options').find('.option_title .current-size-min').text(varient_name);
            } else if ( type == 'Light' || type == 'light' ) {
                 $(parent_div).find('.product-options').find('.option_title .current-light-min').text(varient_name);
            }
           
           	$( parent_div ).find('.product-options').find('input').first().prop("checked", true);
         } else if( number_opts == 2 ) {
           		let style = "";
            	let size = "";
           		let color = "";
           		let light = "";
           		$( parent_div ).find('.product-options').each( function( i, obj ) {
                  	$( obj ).find('.clearfix').find('input').first().prop("checked", true);
                  	let varient_name	=  	$( obj ).find('.clearfix').find('input').first().data('value');
                    let type 			= 	$( obj ).find('.clearfix').find('.option_title .swatch-type ').text();

                  
                  
                    if( $(obj).find('.clearfix').hasClass('swatch-type-min-style') ) {
                        $(obj).find('.clearfix').find('.option_title .current-style-min').text( varient_name );
                        style = $( obj ).find('input').first().val();
                    } else if ( $(obj).find('.clearfix').hasClass('swatch-type-min-size') ) {
                        $(obj).find('.clearfix').find('.option_title .current-size-min').text( varient_name );
                        size = $( obj ).find('input').first().val();
                    }else if ( $(obj).find('.clearfix').hasClass('swatch-type-min-color') ) {
                        $(obj).find('.clearfix').find('.option_title .current-color-min').text( varient_name );
                        color = $( obj ).find('input').first().val();
                    }else if ( $(obj).find('.clearfix').hasClass('swatch-type-min-light') ) {
                        $(obj).find('.clearfix').find('.option_title .current-light-min').text( varient_name );
                        light = $( obj ).find('input').first().val();
                    }
                });

           	 	all_varients.forEach( function ( item, index ) {
               		if( item.option1 == style && item.option2 == size ) {
                      	varient_id 	= item.id 
                    }else if ( item.option1 == color && item.option2 == size  ) {
                      	varient_id 	= item.id 
                    }else if ( item.option1 == color && item.option2 == light  ) {
                      	varient_id 	= item.id 
                    }
                    if( item.option1 == style || item.option1 == color ) {
                        if( kitBuilderInfo[item.id][user_loc] > 0  ) {
                          $(parent_div).find('.product-options').find('input[name=product-option-1][value="' + item.option2 + '"]').next().removeClass('soldout');
                        }else{
                          $(parent_div).find('.product-options').find('input[name=product-option-1][value="' + item.option2 + '"]').next().addClass('soldout');
                        }
                    }
                });
         }

         if( typeof kitBuilderInfo[varient_id] != 'undefined' ) {
            sold_out = ( kitBuilderInfo[varient_id][user_loc] > 0 ) ? false : true ;
         }
        
      	 if( sold_out ) {
            $(parent_div).find('.add_min_to_cart').addClass('sold');
            $(parent_div).find('.add_min_to_cart').attr('disabled' , true );
            $(parent_div).find('.add_min_to_cart span').text('Sold Out');
         } else {
           	$(parent_div).find('.add_min_to_cart').removeClass('sold');
            $(parent_div).find('.add_min_to_cart').attr('disabled' , false );
            $(parent_div).find('.add_min_to_cart span').text('Add to Cart');
         }
      
      	 $( parent_div ).find('.add_min_to_cart').data('varient_id', varient_id );
      	 $('.all-min-products').hide();
    });

  
	$('input[type=radio][name=bedStatus]').change(function() {
       	if (this.value == 'allot') {
        	alert("Allot Thai Gayo Bhai");
    	} else if (this.value == 'transfer') {
        	alert("Transfer Thai Gayo");
    	}
    });

  
  	// on click swatch emelent of the min product in the complete your order section   		
  	$(document).on('change', '.product-options input[type=radio]', function(){
      	var current_element = $(this);
      	let image_url 	= $(this).data('image');
      	let varient_name = $(this).data('value');
      	let type = $(this).parents('.product-options').find('.option_title .swatch-type').text();
      
      	if( type == 'style' || type == 'Style' ) {
          	$(this).parents('.product-options').find('.option_title .current-style-min').text(varient_name);
        } else if ( type == 'Color' || type == 'color' ) {
          	$(this).parents('.product-options').find('.option_title .current-color-min').text(varient_name);
        } else if ( type == 'Size' || type == 'size' ) {
          	$(this).parents('.product-options').find('.option_title .current-size-min').text(varient_name);
        } else if ( type == 'Light' || type == 'light' ) {
          	$(this).parents('.product-options').find('.option_title .current-light-min').text(varient_name);
        }
      
      
      	let number_opts = $(this).parents('.min-products-detail').find('.product-options').length;
      	let varient_id = '';
      	let sold_out = false;
       	let product_id = $(this).data('product_id');
      	let varients =  $(this).parents(".min-product-variants-"+ product_id).data('varients') ;
      	
      	if( isJson( varients )  ) {
        	varients = JSON.parse( JSON.parse( varients ) );
        }
      
      	if( number_opts == 1 ){
             varient_id 	= $(this).data('id');
           	 sold_out = ( $(this).hasClass('soldout') ) ? true : false;
              if( image_url != "" ) {
                	$(this).parents('.min-products-detail').find('.min_image').attr('src', image_url  );
              }
    	} else if( number_opts == 2 ) {
          	let style = "";
          	let size = "";
          	let color = "";
          	let light = "";
          	var item_obj;
          
          $(current_element).parents(".min-product-variants-" + product_id ).find('.product-options').each( function( i, obj ) {
              	if($(obj).find('.clearfix').hasClass('swatch-type-min-style') ) {
                  	style = $(obj).find('input[name=product-option-0]:checked').val();
                } else if( $(obj).find('.clearfix').hasClass('swatch-type-min-size') ) {
                  	size =  $(obj).find('input[name=product-option-1]:checked').val();
              	}else if( $(obj).find('.clearfix').hasClass('swatch-type-min-color') ) {
                  	color =  $(obj).find('input[name=product-option-0]:checked').val();
              	}else if( $(obj).find('.clearfix').hasClass('swatch-type-min-light') ) {
                  	light =  $(obj).find('input[name=product-option-1]:checked').val();
              	}	
            });
          
           	varients.forEach( function ( item, index ) {
              	if( item.option1 == style && item.option2 == size ) {
                  	item_obj = item;
                	varient_id 	= item.id ;
                    image_url = item.featured_image.src;
              	}else if ( item.option1 == color && item.option2 == size  ) {
                  	item_obj = item;
                    varient_id 	= item.id 
                    image_url = item.featured_image.src;
                }else if ( item.option1 == color && item.option2 == light  ) {
                  	item_obj = item;
                    varient_id 	= item.id 
                    image_url = item.featured_image.src;
                }

                if( item.option1 == style || item.option1 == color ) {
                    if( kitBuilderInfo[item.id][user_loc] > 0  ) {
                        $(current_element).parents(".min-product-variants-" + product_id ).find('.product-options').find('input[name=product-option-1][value="' + item.option2 + '"]').next().removeClass('soldout');
                    }else{
                        $(current_element).parents(".min-product-variants-" + product_id ).find('.product-options').find('input[name=product-option-1][value="' + item.option2 + '"]').next().addClass('soldout');
                    }
                }
            });


            if( image_url != "" ) {
                $(this).parents('.min-products-detail').find('.min_image').attr('src', image_url  );
            }
      
          
            const  LITTLE_COURIER_GLOVE = [31680495255599,31680495288367,31680495321135,31680495353903,31680495386671,31680495419439];
       		const  DEFRANC_GLOVE = [31680495452207,31680495484975,31680495517743];
       		const  BULLITT_GLOVE = [31680495157295, 31680495190063, 31680495222831];
          
          	const set_light_varients = [41035518246959,41035518312495,41035518378031];
       		const all_light_varients = [41035501633583,41035518214191,41035501666351,41035518279727,41035501699119,41035518345263];
          
          	var variant_price = '<strong>';
          
           if( strikethrough_discounted_price.bike_bell.was_price == '' || strikethrough_visibility_mincart != 'true' ){
                        
                 if(item_obj.compare_at_price){
                	variant_price +='<del>'+formatMoneyStripTrailingZeros(item_obj.compare_at_price , $('body').data('money-format'))+'</del>';
              	}
          		variant_price +=formatMoneyStripTrailingZeros(item_obj.price , $('body').data('money-format'))+'</strong>';
          		$(current_element).parents('.min-products-detail').find('.tm-compare_price').html(variant_price);
                      
           }else if ( LITTLE_COURIER_GLOVE.includes(varient_id) || DEFRANC_GLOVE.includes(varient_id) || BULLITT_GLOVE.includes(varient_id) ) {
              
             var helmet = false;
       
       		 $.ajax({
                  url: '/cart.js',
                  dataType: "json",
                  cache: false,
                  success: function( cart ) {
                    	$.each( cart.items , function( index, item ) {
                          if( item.handle == 'mips-helmet' ){
                              helmet = true;
                          }else if( item.handle == 'bike-helmet' ){
                              helmet = true;
                          }
                        });
                      if( helmet ) {
							if ( LITTLE_COURIER_GLOVE.includes(varient_id) ) {
                                variant_price +='<del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.little_courier_glove.was_price, $('body').data('money-format'))+'</del>';
                                variant_price += formatMoneyStripTrailingZeros(strikethrough_discounted_price.little_courier_glove.dis_price, $('body').data('money-format'))+'</strong>';
               					$(current_element).parents('.min-products-detail').find('.tm-compare_price').html(variant_price);
                            }else if( DEFRANC_GLOVE.includes(varient_id) ) {
                                variant_price +='<del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.defrance_glove.was_price, $('body').data('money-format'))+'</del>';
                				variant_price += formatMoneyStripTrailingZeros(strikethrough_discounted_price.defrance_glove.dis_price, $('body').data('money-format'))+'</strong>';
               					$(current_element).parents('.min-products-detail').find('.tm-compare_price').html(variant_price);
                            }else if( BULLITT_GLOVE.includes(varient_id) ) {
    		      				variant_price +='<del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.bullitt_glove.was_price, $('body').data('money-format'))+'</del>';
                				variant_price += formatMoneyStripTrailingZeros(strikethrough_discounted_price.bullitt_glove.dis_price, $('body').data('money-format'))+'</strong>';
               					$(current_element).parents('.min-products-detail').find('.tm-compare_price').html(variant_price);
                            }
                      } else {
                        	if(item_obj.compare_at_price){
                                variant_price +='<del>'+formatMoneyStripTrailingZeros(item_obj.compare_at_price , $('body').data('money-format'))+'</del>';
                            }
                            variant_price +=formatMoneyStripTrailingZeros(item_obj.price , $('body').data('money-format'))+'</strong>';
                            $(current_element).parents('.min-products-detail').find('.tm-compare_price').html(variant_price);
                      }
                    }
               });
             
             
            }else if ( set_light_varients.includes(varient_id) || all_light_varients.includes(varient_id) ) {
 
              var helmet = false;
       
       		  $.ajax({
                  url: '/cart.js',
                  dataType: "json",
                  cache: false,
                  success: function( cart ) {
                    	$.each( cart.items , function( index, item ) {
                          if( item.handle == 'mips-helmet' ){
                              helmet = true;
                          }else if( item.handle == 'bike-helmet' ){
                              helmet = true;
                          }else if( item.handle == 'kids-helmet' ){
                              helmet = true;
                          }
                        });
                    
                      if( helmet ) {
							if ( set_light_varients.includes(varient_id) ) {
                                variant_price +='<del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.set_light.was_price, $('body').data('money-format'))+'</del>';
                				variant_price += formatMoneyStripTrailingZeros(strikethrough_discounted_price.set_light.dis_price, $('body').data('money-format'))+'</strong>';
               					$(current_element).parents('.min-products-detail').find('.tm-compare_price').html(variant_price);
                            }else {
                                variant_price +='<del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.all_light.was_price, $('body').data('money-format'))+'</del>';
                				variant_price += formatMoneyStripTrailingZeros(strikethrough_discounted_price.all_light.dis_price, $('body').data('money-format'))+'</strong>';
               					$(current_element).parents('.min-products-detail').find('.tm-compare_price').html(variant_price);
                            }
                      } else {
                        	if(item_obj.compare_at_price){
                                variant_price +='<del>'+formatMoneyStripTrailingZeros(item_obj.compare_at_price , $('body').data('money-format'))+'</del>';
                            }
                            variant_price +=formatMoneyStripTrailingZeros(item_obj.price , $('body').data('money-format'))+'</strong>';
                            $(current_element).parents('.min-products-detail').find('.tm-compare_price').html(variant_price);
                      }
                    }
               });
              
            } else {
              
              	if(item_obj.compare_at_price){
                	variant_price +='<del>'+formatMoneyStripTrailingZeros(item_obj.compare_at_price , $('body').data('money-format'))+'</del>';
              	}
          		variant_price +=formatMoneyStripTrailingZeros(item_obj.price , $('body').data('money-format'))+'</strong>';
          		$(current_element).parents('.min-products-detail').find('.tm-compare_price').html(variant_price);
            
            }
        }
          
         if( typeof kitBuilderInfo[varient_id] != 'undefined' ) {
            sold_out = ( kitBuilderInfo[varient_id][user_loc] > 0 ) ? false : true ;
         }
      
      	if( sold_out ) {
        	$(current_element).parents('.min-products-detail').find('.add_min_to_cart').addClass('sold');
            $(current_element).parents('.min-products-detail').find('.add_min_to_cart').attr('disabled' , true );
            $(current_element).parents('.min-products-detail').find('.add_min_to_cart span').text('Sold Out');
        } else {
            $(current_element).parents('.min-products-detail').find('.add_min_to_cart').removeClass('sold');
            $(current_element).parents('.min-products-detail').find('.add_min_to_cart').attr('disabled' , false );
            $(current_element).parents('.min-products-detail').find('.add_min_to_cart span').text('Add to Cart');
      	}
      
      	$(current_element).parents('.min-products-detail').find('.add_min_to_cart').data('varient_id', varient_id );
  	});
  
  	// back to min products 
	$(document).on('click', '.back_to_min_products ', function(){
    	$('.all-min-products').show();
      	$('.min-products-detail').hide();
  	});
  
	// add min product to cart    	
  	$(document).on('click', '.add_min_to_cart ', function(){
        var $addToCartBtn = $(this);
      	var variant_id = $(this).data('varient_id');
      	var data = { "id": variant_id, "quantity": 1 };
      	
      	if( variant_id != '' ) {
            jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                beforeSend: function() {
                    $addToCartBtn.attr('disabled', 'disabled').addClass('disabled is--sending');
                    $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
                },
                success: function( response ) {
                  const { 
                    title: name,
                    product_id: id,
                    final_price: price,
                    vendor: brand,
                    product_type,
                    quantity,
                    variant_id: variant,

                   } = response;
                  console.warn("ee_addToCart min::", thousand.globals.currentProductJSON || thousand.utils.getCurrentProductJSON)
                    window.setTimeout(function(){
                        $addToCartBtn.removeAttr('disabled').removeClass('disabled is--sending');
                        $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
                    }, 1000);
                     $.ajax({
                        url: '/cart.js',
                        dataType: "json",
                        cache: false,
                        success: function( cart ) {
                          setTimeout( function() {
                            refreshCart( cart );

                            if( $('body').hasClass('fancybox-active') ) {
                                $.fancybox.close();
                            }

                            if($('#header').is(':visible')) {
                                $('#header .cart_container').addClass('active_link');
                            } else if ($('.sticky_nav--stick').length) {
                                $('.sticky_nav .cart_container').addClass('active_link');
                            } else {
                                $('.top_bar .cart_container').addClass('active_link');
                            }

                            //block scrolling on mobile
                            if ( $(window).width() <= 798 ) {
                                var $cart_container = $(this).parent();
                                if( $cart_container.hasClass('active_link') ) {
                                    $('body').addClass('blocked-scroll');
                                } else {
                                    $('body').addClass('blocked-scroll');
                                }
                            }

                          }, 500);
                        }
                    });
                },
               error: function( XMLHttpRequest ) {
                    var response = eval('(' + XMLHttpRequest.responseText + ')');
                    $('.add-min-product-to-cart-error').text( response.description );
                    response = response.description;
                    $addToCartBtn.removeAttr('disabled').removeClass('disabled is--sending');
                    $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
                }
            });
      	}
  	 });

	

	// check if is json 
    function isJson( str ) {
        try {
            JSON.parse( str );
        } catch (e) {
            return false;
        }
        return true;
    }
	
    // on add to cart create HTML of complete your kit
	function addCompleteYourOrder(  mips_col, bike_col, kids_col, glove, sticker, bells, visors, light, kids_sticker, kids_bell, show_cart, h2_col ) {
      	let inv_location = getCookie('user_location_warehouse');
      	var coll_name = false;
      	if( mips_col  ) {
        	coll_name = 'chapter-cart-cross-sell';
      	} else if ( bike_col ) {
          	coll_name = 'heritage-cart-cross-sell';
      	} else if ( h2_col ) {
          	coll_name = 'heritage-cart-cross-sell';
      	} else if ( kids_col ) {
            coll_name = 'thousand-jr-cart-cross-sell';
      	}
      	$('.complete-kit-sec').html('');
      	if( coll_name  ) {
          	var kit_html = '';
          	$.ajax({
                dataType: "json",
                async: false,
                cache: false,
                url: "/collections/" + coll_name + "/products.json",
                success: function ( data )  {
                  	kit_html = '<div class="all-min-products">';
                  	kit_html += '<h2 class="mini_cart_title center"> Bundle & Save </h2>';
                    kit_html += '<p class="center">Unlock more savings when you add accessories to cart</p>';
                  kit_html +=	'<div class="row ths-completeKit">';
                  	$.each( data.products , function( index, item ) {
                        var style = '';
                      	var pr_title = item.title;
                        if( inv_location == 'eur' ) {
                          if( item.handle == 'cable-bike-lock' || item.handle == 'u-lock-bike-lock' || item.handle == 'bike-lights' ) {
                              style = 'display:none;';
                          }
                        }
                      
                      	if( item.handle == 'bike-lights' ) {
                           pr_title = pr_title.replace('Magnetic ','');
                        }
                      	
                      	kit_html +=	'<div class="five columns center mini_cart_kit" style="'+ style  +'">';
                      	kit_html += '<a class="blue_plus js-quick-shop-link" data-productid="'+ item.id  +'"  data-handle="'+ item.handle +'"><img src="' + item.variants[0].featured_image.src  + '"/>';
                        kit_html +=	'<h4>' + pr_title  + '</h4>';
                        kit_html +=	'<div>';
                      	if( strikethrough_discounted_price.bike_bell.was_price == '' || strikethrough_visibility_mincart != 'true' ){
                        
                        kit_html +=	'<strong>';
                          if(item.variants[0].compare_at_price){
                            kit_html +=	'<del>'+formatMoneyStripTrailingZeros(item.variants[0].compare_at_price , $('body').data('money-format'))+'</del>';
                          }
                          kit_html +=	'$'+Math.trunc( item.variants[0].price )  + '</strong>'
                      
                        }else if( item.handle == 'bike-bell'  ) {

                            kit_html +=	' <span> <del> '+formatMoneyStripTrailingZeros(strikethrough_discounted_price.bike_bell.was_price, $('body').data('money-format'))+' </del> </span>';
                            kit_html +=	' <span> '+formatMoneyStripTrailingZeros(strikethrough_discounted_price.bike_bell.dis_price, $('body').data('money-format'))+' </span>';
  
                        }else if( item.handle == 'helmet-stickers' ){
                             kit_html +=	'<span> <del> '+formatMoneyStripTrailingZeros(strikethrough_discounted_price.helmet_stickers.was_price, $('body').data('money-format'))+' </del> </span>';
                             kit_html += '<span> '+formatMoneyStripTrailingZeros(strikethrough_discounted_price.helmet_stickers.dis_price, $('body').data('money-format'))+' </span>';
                          
                        }else if( item.handle == 'bike-gloves' ){
                              kit_html +=	'<span> <del> '+formatMoneyStripTrailingZeros(strikethrough_discounted_price.little_courier_glove.was_price, $('body').data('money-format'))+' </del> </span>';
                              kit_html +=	'<span>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.little_courier_glove.dis_price, $('body').data('money-format'))+' </span>';
                          
                        }else if( item.handle == 'chapter-visors' ){
                           kit_html +=	'<span><del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.chapter_visors.was_price, $('body').data('money-format'))+' </del> </span>';
                           kit_html +=	'<span> '+formatMoneyStripTrailingZeros(strikethrough_discounted_price.chapter_visors.dis_price, $('body').data('money-format'))+' </span>';
                          
                        }else if( item.handle == 'kids-stickers' ){
                           kit_html +=	'<span><del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.kids_stickers.was_price, $('body').data('money-format'))+' </del> </span>';
                           kit_html +=	'<span>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.kids_stickers.dis_price, $('body').data('money-format'))+' </span>';
                          
                        }else if( item.handle == 'kids-bell' ){
                           kit_html +=	'<span> <del> '+formatMoneyStripTrailingZeros(strikethrough_discounted_price.kids_bell.was_price, $('body').data('money-format'))+' </del> </span>';
                           kit_html +=	'<span> '+formatMoneyStripTrailingZeros(strikethrough_discounted_price.kids_bell.dis_price, $('body').data('money-format'))+' </span>';
                          
                        }else if( item.handle == 'bike-lights'  ){
                           kit_html +=	'<span><del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.set_light.was_price, $('body').data('money-format'))+' </del> </span>';
                           kit_html +=	'<span>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.set_light.dis_price, $('body').data('money-format'))+' </span>';
                          
                        }else if( item.handle == 'u-lock-bike-lock' || item.handle == 'cable-bike-lock'  ){
                           kit_html +=	'<span><del> '+formatMoneyStripTrailingZeros(strikethrough_discounted_price[item.handle].was_price, $('body').data('money-format'))+' </del> </span>';
                           kit_html +=	'<span> '+formatMoneyStripTrailingZeros(strikethrough_discounted_price[item.handle].dis_price, $('body').data('money-format'))+' </span>';
                          
                        } else {
                           
                          kit_html +=	'<strong>';
                          if(item.variants[0].compare_at_price){
                            kit_html +=	'<del>'+formatMoneyStripTrailingZeros(item.variants[0].compare_at_price , $('body').data('money-format'))+'</del>';
                          }
                          kit_html +=	'$'+Math.trunc( item.variants[0].price )  + '</strong>'
                          
                        }
                        kit_html +=	'</div>';
                        
                        kit_html += '<span class="blue_plus_icon">+</span></a>';
                        kit_html +=	'</div>';
                    });
                    kit_html += '</div>';
                  kit_html += '</div>';
                  	$.each( data.products , function( index, item ) {
                      	var pro_title = item.title;
                      	if( item.handle == 'bike-lights' ) {
                           pro_title = pro_title.replace('Magnetic ','');
                        }
                      
                    	kit_html += '<div style="display:none;" class ="min-products-detail min-products-detail-'+ item.handle +' min-products-detail-'+ item.id +'">';
                      	kit_html += '<div class="min-products-detail-title">';
                      	kit_html += '<span class="back_to_min_products">';
                      	kit_html += '<img src="//www.explorethousand.com/cdn/shop/t/519/assets/back_small.png?v=139870048664814976531776188341"/>';
                      	kit_html += '</span>';
                      	kit_html += '<h2 class="mini_producr_title center">'+ pro_title +' </h2>';
                      	kit_html += '</div>';
                      	kit_html += '<div class="clearfix ">';
                      	kit_html += '<div class="six columns">';
                      	kit_html += '<a href="/products/' + item.handle  +'">';
                      	kit_html += '<img class="min_image" src="' + item.variants[0].featured_image.src  + '"/>';
                      	kit_html += '</a>';
                      	kit_html += '</div>';
                      	kit_html += "<div class='ten columns min-product-variants-" + item.id + "' data-varients='" +  JSON.stringify( JSON.stringify( item.variants ) ) + "'>";
                      	kit_html +=	'<div class="complete_kit_price tm-compare_price">';
                       	
                       if( strikethrough_discounted_price.bike_bell.was_price == '' || strikethrough_visibility_mincart != 'true' ){
                        
                          	kit_html += '';
                          	if(item.variants[0].compare_at_price){
                            	kit_html +=	'<del>'+formatMoneyStripTrailingZeros(item.variants[0].compare_at_price , $('body').data('money-format'))+'</del>';
                          	}
                          	kit_html += '$'+ Math.trunc( item.variants[0].price );
                      
                        }else if( item.handle == 'bike-bell' ) {
                               kit_html += '<del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.bike_bell.was_price, $('body').data('money-format'))+'</del>';
                       		kit_html += formatMoneyStripTrailingZeros(strikethrough_discounted_price.bike_bell.dis_price, $('body').data('money-format'));
                        
                        }else if( item.handle == 'helmet-stickers' ){
                               kit_html += '<del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.helmet_stickers.was_price, $('body').data('money-format'))+'</del>';
                          	kit_html += formatMoneyStripTrailingZeros(strikethrough_discounted_price.helmet_stickers.dis_price, $('body').data('money-format'));

                        }else if( item.handle == 'bike-gloves' ){
                               kit_html += '<del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.little_courier_glove.was_price, $('body').data('money-format'))+'</del>';
                           	kit_html += formatMoneyStripTrailingZeros(strikethrough_discounted_price.little_courier_glove.dis_price, $('body').data('money-format'));
                          
                        }else if( item.handle == 'chapter-visors' ){
                               kit_html += '<del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.chapter_visors.was_price, $('body').data('money-format'))+'</del>';
                           	kit_html += formatMoneyStripTrailingZeros(strikethrough_discounted_price.chapter_visors.dis_price, $('body').data('money-format'));
                          
                        }else if( item.handle == 'kids-stickers' ){
                               kit_html += '<del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.kids_stickers.was_price, $('body').data('money-format'))+'</del>';
                           	kit_html += formatMoneyStripTrailingZeros(strikethrough_discounted_price.kids_stickers.dis_price, $('body').data('money-format'));
                          
                        }else if( item.handle == 'kids-bell' ){
                               kit_html += '<del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.kids_bell.was_price, $('body').data('money-format'))+'</del>';
                           	kit_html += formatMoneyStripTrailingZeros(strikethrough_discounted_price.kids_bell.dis_price, $('body').data('money-format'));
                          
                        }else if( item.handle == 'bike-lights' ){
                              kit_html += '<del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price.set_light.was_price, $('body').data('money-format'))+'</del>';
                           kit_html += formatMoneyStripTrailingZeros(strikethrough_discounted_price.set_light.dis_price, $('body').data('money-format'));

                        }else if( item.handle == 'u-lock-bike-lock' || item.handle == 'cable-bike-lock'  ){
                              kit_html += '<del>'+formatMoneyStripTrailingZeros(strikethrough_discounted_price[item.handle].was_price, $('body').data('money-format'))+'</del>';
                          	kit_html += formatMoneyStripTrailingZeros(strikethrough_discounted_price[item.handle].dis_price, $('body').data('money-format'));
                          
                        } else {
                           
                          	if(item.variants[0].compare_at_price){
                            	kit_html +=	'<del>'+formatMoneyStripTrailingZeros(item.variants[0].compare_at_price , $('body').data('money-format'))+'</del>';
                          	}
                          	kit_html += '$'+ Math.trunc( item.variants[0].price );
                          
                        }

                        kit_html += '</div>';
                      
                      	var option_index = 0;
                      	$.each( item.options , function( i, o ) {
                          	var is_color_min = false;
                          	var is_size_min = false;
                          	var is_style_min = false;
                          	var is_light_min = false;
                          	option_index = i;
                          	if( o.name == 'Style' || o.name == 'style' ) {
                             	is_style_min = true;
                          	} 
                          	if ( o.name == 'Size' || o.name == 'size' ) {
                             	is_size_min = true;
                          	}
                          	if ( o.name == 'color' || o.name == 'Color' || o.name == 'colour' || o.name == 'Colour' ) {
                             	is_color_min = true;
                          	}
                          	if ( o.name == 'Light' || o.name == 'light' ) {
                             	is_light_min = true;
                          	}
                          	kit_html += '<div class="product-options">';
                          	kit_html += '<div class="clearfix swatch-type-min-'+ (o.name).toLowerCase() +'" data-option-index="'+ option_index +'">';
                          	kit_html += '<div class="option_title">';
                          	kit_html += '<span class="swatch-type">'+ (o.name).toLowerCase() +'</span>';
                          	if(  is_color_min ) {
                           		kit_html += '<span class="swatch-seperator"> - </span> <span class="current-color-min"></span>';
                          	} else if( is_size_min ) {
                            	kit_html += '<span class="swatch-seperator"> - </span> <span class="current-size-min"></span>';
                          	} else if( is_style_min ) {
                            	kit_html += '<span class="swatch-seperator"> - </span> <span class="current-style-min"></span>';
                          	} else if( is_light_min ) {
                            	kit_html += '<span class="swatch-seperator"> - </span> <span class="current-light-min"></span>';
                          	}
                          	kit_html += '</div>';
                          	var options_values = o.values;
                          	var check_var_opt = [];
                          	$.each( item.variants , function( k, v ) {
                              	var op = option_index + 1;
                              	var op_index = 'option' + op;
                                if( options_values.includes( v[op_index] ) ) {
                                  	 if( ! check_var_opt.includes( v[op_index] ) ) {
                                  	  check_var_opt.push( v[op_index] );
                                      var soldClass = ( v.available ) ? 'available' : 'soldout';
                                      var imageUrl = ( typeof v.featured_image.src != 'undefined' ) ? v.featured_image.src : '';
                                      var checked = ( k == 0 ) ? 'checked' : '';
                                      var handle = (v[op_index]).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                                      if( is_size_min  ) {
                                         var element_class = "Size "+ handle + "-swatch";
                                      } else if( is_style_min  ) {
                                         var element_class = "style "+ handle + "-swatch";
                                      } else if( is_color_min  ) {
                                         var element_class = "color "+ handle + "-swatch";
                                      }	else if( is_light_min  ) {
                                         var element_class = "light "+ handle + "-swatch";
                                      }
                                       
                                      kit_html += '<div class = "swatch-min-item">';
                                      if( is_size_min ) {
                                        	kit_html += '<input id="option-'+ v.id +'" type="radio" data-value="'+ v[op_index] +'" data-product_id="'+ v.product_id +'" data-id="'+ v.id +'" data-is-color="'+ is_color_min +'" data-variant-name="'+ v.title +'" name="product-option-'+ option_index +'" value="'+ v[op_index] +'" '+ checked  +' class="'+ soldClass +'" />';
                                      } else {
                                        	kit_html += '<input id="option-'+ v.id +'" type="radio" data-value="'+ v[op_index] +'" data-product_id="'+ v.product_id +'" data-id="'+ v.id +'" data-is-color="'+ is_color_min +'" data-variant-name="'+ v.title +'" name="product-option-'+ option_index +'" value="'+ v[op_index] +'" '+ checked  +' class="'+ soldClass +'" data-image="'+ imageUrl +'" />';
                                      }
                                       
                                      kit_html += '<div data-id="'+ v.id +'" class="swatch-min-element '+ soldClass + " " + element_class +'">';
                                      kit_html += '<label for = "option-'+ v.id +'">';
                                      if( is_size_min ) {
                                        if( v[op_index] == 'Extra Small' ) {
                                            kit_html += '<span class="swatch-display-min"> XS </span>';
                                        } else if( v[op_index] == 'Small'  ) {
                                            kit_html += '<span class="swatch-display-min"> S </span>';
                                        } else if( v[op_index] == 'Medium'  ) {
                                            kit_html += '<span class="swatch-display-min"> M </span>';
                                        } else if( v[op_index] == 'Large'  ) {
                                            kit_html += '<span class="swatch-display-min"> L </span>';
                                        } else if( v[op_index] == 'Extra Large'  ) {
                                            kit_html += '<span class="swatch-display-min"> XL </span>';
                                        }
                                      }
                                      
                                       var assetsoldoutUrl = "//www.explorethousand.com/cdn/shop/t/519/assets/soldout_small.png?v=26608208942692023401776188338";

                                      kit_html += '<img class="crossed-out" src="'+ assetsoldoutUrl +'">';
                                      kit_html += '</label>';
                                      kit_html += '</div>';
                                      kit_html += '</div>';
                                    }
                                }
                          	});
                          	kit_html += '</div>';
                            kit_html += '</div>';
                        });
                        kit_html += '</div>';
                        kit_html += '<div class="purchase-details__buttons purchase-details__spb--">';
                         if(item.handle === "bike-gloves" || item.handle === "remix-gloves" ){
                          kit_html += `<div class="see-fit-guide" style="padding-left: 148px; padding-bottom: 24px;"><a href="javascript:void(0)" data-fancybox="fitguide" data-src="#size-guide-fit-${item.handle}" class="size_chart">See Fit Guide</a></div>`;
                        }
                        if(item.handle === "remix-socks"){
                          kit_html += `<div style="padding-left: 148px; padding-bottom: 24px;"><p>S/M fits US M shoe size 7-9.5, W shoe size 6-8.5</p><p>L/XL fits US M shoe size 10-13, W shoe size 9+</p></div>`
                        }    
                        kit_html += 
                        `<div class="js-sizechart-lightbox pp-without-bg" id="size-guide-fit-bike-gloves" style="display: none">
                          <div class="size-chart-wrap">
                            <div class="fit-guide-section gloves-fit-guide-section">
                              <div class="container">
                                  <img src="https://cdn.shopify.com/s/files/1/0836/6919/files/gloves-fit-guide-white_800x.png?v=1615842470" />
                                  <ul>
                                      <li>Wrap a phone charging cord around your hand just below the knuckles and compare with a ruler.</li>
                                      <li>Gloves should fit snug but not constricting.</li>
                                  </ul>
                                  <table>
                                      <thead>
                                          <tr>
                                              <th width="30%">Size</th>
                                              <th width="30%">CM</th>
                                              <th width="30%">Inches</th>                   
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr>
                                              <td>S</td>
                                              <td>20</td>
                                              <td>7 1/2-8</td>
                                          </tr>
                                          <tr>
                                              <td>M</td>
                                              <td>23</td>
                                              <td>8 1/2-9</td>
                                          </tr>
                                          <tr>
                                              <td>L</td>
                                              <td>25</td>
                                              <td>10 1/2-11</td>
                                          </tr>   
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                          </div>
                        </div>

                        <div class="js-sizechart-lightbox pp-without-bg" id="size-guide-fit-remix-gloves" style="display: none">
                          <div class="size-chart-wrap">

                            <div class="fit-guide-section gloves-fit-guide-section">
                              <div class="container">
                                <div class="eight columns medium-down--one-whole alpha">
                                  <img src="https://cdn.shopify.com/s/files/1/0836/6919/files/ho22-gloves-hand_03_1600x.png?v=1668534597" />
                                </div>
                                <div class="eight columns medium-down--one-whole omega product-copy-section">
                                  <p>These gloves stretch. If you're in between sizes, size down for a better fit.</p>
                                  <p>Measurement A is the most imporant of the two measurements. Measure the width of your hand, find your size on the size chart, and line up measurement B to see if it matches the length.</p>
                                  <table>
                                      <thead>
                                          <tr>
                                              <th width="30%">Size</th>
                                              <th width="30%">A</th>
                                              <th width="30%">B</th>                   
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr>
                                              <td>XS</td>
                                              <td>3-1/4" /7.6CM</td>
                                              <td>7-1/2" /19CM</td>
                                          </tr>
                                          <tr>
                                              <td>S</td>
                                              <td>3-3/8" /8.6CM</td>
                                              <td>7-3/4" /19.7CM</td>
                                          </tr>
                                          <tr>
                                              <td>M</td>
                                              <td>3-1/2" /8.9CM</td>
                                              <td>8" /20.3CM</td>
                                          </tr>
                                          <tr>
                                              <td>L</td>
                                              <td>3-3/4" /9.5CM</td>
                                              <td>8-1/4" /21CM</td>
                                          </tr>   
                                          <tr>
                                              <td>XL</td>
                                              <td>4" /10.2CM</td>
                                              <td>8-1/2" /21.6CM</td>
                                          </tr>   
                                      </tbody>
                                  </table>
                                </div>               
                              </div>
                          </div>
                          </div>
                        </div>`;

                        kit_html += '<button data-varient_id="" type="button" name="add" class="add_min_to_cart" data-label="Add to Cart">';
                        kit_html += '<span class="text">Add to cart</span>';
                        kit_html += '</button>';
                        kit_html += '<p class="add-min-product-to-cart-error"></p>';
                        kit_html += '</div>';
                        kit_html += '</div>';
                        kit_html += '</div>';
                   	});
                  	$('.complete-kit-sec').html( kit_html );
                    if (!show_cart ) {
                      jQuery('.tm-hide-on-scroll').addClass('tm-hide-on-cartopen');
                  	}
                }
              
          	});
      	}
	}


    
	// on outside click 
    jQuery(document).click(function(e){
        var CartElement = jQuery(".cart_container");
        detectOutsideClick(e, CartElement);
    });

    
	// detect hashtags and similar users li outside click
    function detectOutsideClick( e, myTarget ){
      	var clicked = e.target;
      	if(jQuery.trim(myTarget) != '') {
          	if(jQuery(myTarget) != clicked && jQuery(clicked).closest(jQuery(myTarget)).length == 0) {
              if( jQuery('body').hasClass('cart-background')  ) {
                 	jQuery('body').removeClass('cart-background');
                   	jQuery('.cart_content').hide();
              }
            }
        }
    }

	
	// on click cart title on the mobile to close the cart element on mobile ....
	$(document).on('click', '.cart-preview-title', function() {
     	if ( window.matchMedia("(max-width: 767px)").matches ) {
            // The viewport is less than 768 pixels wide then its a mobile or small screen device 
           jQuery('.cart_content__continue-shopping').trigger('click');
        }
	});

$(document).on('click','.holidaybanner-content', function(){
  $(this).siblings('video').hide();
  $('.holidaybanner-content').hide();
  $('.thousand-holiday-banner-mobile').hide();
  $('.yt_holiday_video').show();
	$("#holiday_banner_ytv")[0].src += "&autoplay=1";
})



if ($(document).width() > 600) {
         $(document).ready(function(){
           $('.v_play').on('click',function(){
             $('.v_section').css('display','none');
             $('#v_iframe').css('display','block');
             document.getElementById("v_iframe").src = 'https://www.youtube.com/embed/wgCqIE-HL0M?rel=0&autoplay=1';
           })
        })
        }else{
          $(document).ready(function(){
           $('.v_play').on('click',function(){
             $('#v_video').css('display','none');
             $('#v_iframe').css('display','block');
             $('.v_play').css('display','none');
             document.getElementById("v_iframe").src = 'https://www.youtube.com/embed/wgCqIE-HL0M?rel=0&autoplay=1';
           })
        })
        }



// ZHIVKO JS
window.addEventListener('DOMContentLoaded', (event) => {
  if (window.location.pathname.indexOf('/products/') !== -1) {

    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }
    
    const si_trigger = document.querySelector(".si_trigger");
    const warehouse_location = getCookie('user_location_warehouse');

    if(si_trigger) {
      if(warehouse_location !== "usa") {
        si_trigger.classList.add("hide_important");
      }
    }
  }
  const menu_column_title = document.querySelector(".tm-mega-menu-2 .dropdown_column__menu .dropdown_title a");
});


jQuery('.mobile_nav').click(function(){
  if( jQuery('body').hasClass('blocked-scroll') ) {

    jQuery('body').removeClass('blocked-scroll')
  }  
});

function getUrlParameterAK(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};


// $(function() {
//   $('.kit-tabs-nav a').click(function() {

//     // Check for active
//     $('.kit-tabs-nav li').removeClass('active');
//     $(this).parent().addClass('active');

//     // Display active tab
//     let currentTab = $(this).attr('href');
//     $('.ths-kit-builder-tab').hide();
//     $(currentTab).show();

// //     return false;
//   });
// });